const _fc_props = {};
_fc_props.ante_meridiem = 'AM';
_fc_props.post_meridiem = 'PM';
_fc_props.retry = 'Proovi uuesti';
_fc_props.default = 'Vaikimisi';
_fc_props.origin = 'Päritolu';
_fc_props.day = 'Päev';
_fc_props.loading = 'Laadimine';
_fc_props.list = 'Loend';
_fc_props.error = 'Viga';
_fc_props.save = 'Salvesta';
_fc_props.delete = 'Kustuta';
_fc_props.message = 'Sõnum';
_fc_props.logout = 'Logi välja';
_fc_props.add = 'Lisa';
_fc_props.remove = 'Eemalda';
_fc_props.done = 'Valmis';
_fc_props.other = 'Muu';
_fc_props.interval = 'Intervall';
_fc_props.time = 'Aeg';
_fc_props.speed = 'Kiirus';
_fc_props.longitude = 'Pikkuskraad';
_fc_props.latitude = 'Laiuskraad';
_fc_props.x_minutes = '{0} minutit';
_fc_props.errors = 'Vead';
_fc_props.general = 'Üldine';
_fc_props.messages = 'Sõnumid';
_fc_props.gps_fixes = 'GPS-parandused';
_fc_props.device_id = 'Seadme ID';
_fc_props.vehicle = 'Sõiduk';
_fc_props.employee = 'töötaja';
_fc_props.version = 'Versioon';
_fc_props.statuses = 'Staatused';
_fc_props.edit = 'Redigeeri';
_fc_props.cancel = 'Tühista';
_fc_props.yes = 'Jah';
_fc_props.none = 'Puudub';
_fc_props.item = 'Ese';
_fc_props.never = 'Mitte kunagi';
_fc_props.name = 'Nimi';
_fc_props.average = 'Keskmine';
_fc_props.items = 'Esemed';
_fc_props.true = 'Tõsi';
_fc_props.status = 'Staatus';
_fc_props.distance = 'Kaugus';
_fc_props.ok = 'Olgu';
_fc_props.login = 'Sisselogimine';
_fc_props.next = 'Järgmine';
_fc_props.info = 'Info';
_fc_props.menu = 'Menüü';
_fc_props.not_available = 'Pole kohaldatav';
_fc_props.back = 'Tagasi';
_fc_props.refresh = 'Värskenda';
_fc_props.select = 'Vali';
_fc_props.dispatch = 'Lähetamine';
_fc_props.messaging = 'Sõnumid';
_fc_props.plants = 'Taimed';
_fc_props.last_plants = 'Viimased taimed';
_fc_props.vehicle_types = 'Sõidukitüübid';
_fc_props.employee_types = 'Töötajate tüübid';
_fc_props.employee_groups = 'Töötajate grupid';
_fc_props.equipment_groups = 'Seadmete rühmad';
_fc_props.status_type = 'Staatuse tüüp';
_fc_props.job = 'Töö';
_fc_props.order = 'Telli';
_fc_props.ticket = 'Pileti nr';
_fc_props.small = 'Väike';
_fc_props.medium = 'Keskmine';
_fc_props.large = 'Suur';
_fc_props.reports = 'Aruanded';
_fc_props.payroll = 'Palgaarvestus';
_fc_props.support = 'Tugi';
_fc_props.username = 'Kasutajanimi';
_fc_props.all = 'Kõik';
_fc_props.question = 'Küsimus';
_fc_props.select_employee = 'Valige töötaja';
_fc_props.phone = 'Telefon';
_fc_props.january = 'Jaanuar';
_fc_props.february = 'Veebruar';
_fc_props.march = 'Märts';
_fc_props.april = 'Aprill';
_fc_props.may = 'Mai';
_fc_props.june = 'Juuni';
_fc_props.july = 'Juuli';
_fc_props.august = 'August';
_fc_props.september = 'September';
_fc_props.october = 'Oktoober';
_fc_props.november = 'November';
_fc_props.december = 'Detsember';
_fc_props.are_you_sure_you_want_to_delete = 'Kas oled kindel, et soovid kustutada?';
_fc_props.unknown = 'Tundmatu';
_fc_props.invalid_date_range_report_is_limited_to_x_days = 'Kehtetu kuupäevavahemik: Aruanne on piiratud {0} päevaga';
_fc_props.select_all = 'Vali kõik';
_fc_props.resolution = 'Resolutsioon';
_fc_props.equipment = 'Varustus';
_fc_props.totals = 'Kokku';
_fc_props.region = 'Piirkond';
_fc_props.no_data = 'Andmeid pole';
_fc_props.hotspot = 'Kuumpunkt';
_fc_props.hotspot_type = 'Leviala tüüp';
_fc_props.datetime = 'Kuupäev/kellaaeg';
_fc_props.address = 'Aadress';
_fc_props.retrieving_address = 'Aadressi hankimine...';
_fc_props.address_not_found = 'Aadressi ei leitud';
_fc_props.active_time = 'Aktiivne aeg';
_fc_props.destination_time = 'Sihtkoha aeg';
_fc_props.complete_time = 'Täielik aeg';
_fc_props.status_report = 'Staatuse aruanne';
_fc_props.export_report = 'Ekspordi aruanne';
_fc_props.download_report = 'Laadi alla aruanne';
_fc_props.view_report = 'Kuva aruanne';
_fc_props.duration = 'Kestus';
_fc_props.min = 'Min';
_fc_props.start_date_time = 'Alguskuupäev/kellaaeg';
_fc_props.select_start_date = 'Valige alguskuupäev';
_fc_props.end_date_time = 'Lõppkuupäev/kellaaeg';
_fc_props.select_end_date = 'Valige lõppkuupäev';
_fc_props.trip_time = 'Reisi aeg';
_fc_props.travel_time = 'Reisiaeg';
_fc_props.description = 'Kirjeldus';
_fc_props.map_controls = 'Kaardi juhtnupud';
_fc_props.road = 'Tee';
_fc_props.aerial = 'Õhust';
_fc_props.hybrid = 'Hübriid';
_fc_props.trip = 'Reis';
_fc_props.map = 'Kaart';
_fc_props.plant = 'Taim';
_fc_props.select_date = 'Valige kuupäev';
_fc_props.apply = 'Kandideeri';
_fc_props.save_settings = 'Salvesta sätted';
_fc_props.false = 'Vale';
_fc_props.delete_confirmation = 'Kustutamise kinnitus';
_fc_props.last_name = 'Perekonnanimi';
_fc_props.none_selected = 'Pole valitud';
_fc_props.start_date = 'Alguskuupäev';
_fc_props.group_by = 'Grupeeri alus';
_fc_props.equipment_employee = 'Varustus / töötaja';
_fc_props.inactive = 'Mitteaktiivne';
_fc_props.active = 'Aktiivne';
_fc_props.note_checking_may_affect_performance = 'Märkus. Kontrollimine võib jõudlust mõjutada.';
_fc_props.show_distancefuel_used = 'Näita läbitud vahemaad/kulutatud kütust';
_fc_props.mins = 'Minutit';
_fc_props.threshold_time = 'Lävendiaeg';
_fc_props.include_voided_tickets = 'Kaasa tühistatud piletid';
_fc_props.note_all_times_listed_are_in_minutes = 'Märkus: Kõik loetletud ajad on minutites';
_fc_props.please_select_a_job_order_or_equipment = 'Palun valige töö, tellimus, tehas, seade või töötaja';
_fc_props.device = 'Seade';
_fc_props.select_equipment = 'Valige varustus';
_fc_props.on_enter = 'Sisenemisel';
_fc_props.on_exit = 'Väljumisel';
_fc_props.all_equipment_types = 'Kõik seadmete tüübid';
_fc_props.summary = 'Kokkuvõte';
_fc_props.units = {};
_fc_props.units.liters = 'Liitrid';
_fc_props.type = 'Tüüp';
_fc_props.no_data_available = 'Andmeid pole saadaval';
_fc_props.menu = {};
_fc_props.menu.reports = {};
_fc_props.menu.reports.title = {};
_fc_props.menu.reports.title.breakdown = 'Jaotus';
_fc_props.menu.reports.title.distance_and_fuel_by_region = 'Vahemaa ja kütus piirkonniti';
_fc_props.menu_settings_title_settings = 'Seaded';
_fc_props.menu_settings_title_alerts = 'Teavitused';
_fc_props.menu.settings = {};
_fc_props.menu.settings.title = {};
_fc_props.menu.settings.title.equipment = 'Varustus';
_fc_props.menu_settings_title_hotspots_regions = 'Levialad ja piirkonnad';
_fc_props.days = '{0} päeva';
_fc_props.home = 'Avaleht';
_fc_props.find = 'Leia';
_fc_props.close_this_panel = 'sulge see paneel';
_fc_props.filters = 'Filtrid';
_fc_props.start = 'Alusta';
_fc_props.end = 'Lõpp';
_fc_props.location_details = 'Asukoha üksikasjad';
_fc_props.first_name = 'Eesnimi';
_fc_props.material_per_hour = 'Materjal tunnis';
_fc_props.equipment_pound = 'Varustus #';
_fc_props.equipment_type = 'Seadme tüüp';
_fc_props.options = 'Valikud';
_fc_props.zoom_on_cursor_position = 'Suumi kursori asukoha järgi';
_fc_props.display_equipment_identifier = 'Kuva seadme identifikaator';
_fc_props.view_equipment = 'Vaata seadmeid';
_fc_props.view_hotspots = 'Kuva levialad';
_fc_props.view_regions = 'Vaata piirkondi';
_fc_props.use_standard_filters = 'Kasutage standardfiltreid';
_fc_props.home_plant = 'Kodune taim';
_fc_props.last_plant = 'Viimane taim';
_fc_props.equip_types = 'Varustuse tüübid';
_fc_props.equip_groups = 'Varustusgrupid';
_fc_props.orders = 'Tellimused';
_fc_props.trakitall = 'TrakitALL';
_fc_props.use_equipment_filter = 'Kasutage seadmete filtrit';
_fc_props.all_selected = 'Kõik valitud';
_fc_props.of = 'Kohta';
_fc_props.your_map_session_has_expired = 'Teie kaardiseanss on aegunud, palun värskendage lehte.';
_fc_props.equipment_short = 'Varusta.';
_fc_props.job_info_for = 'Tööinfo';
_fc_props.order_info_for = 'Tellimuse info';
_fc_props.ticket_info_for_vehicle = 'Sõiduki piletiinfo';
_fc_props.inbox = 'Postkast';
_fc_props.outbox = 'Väljundkast';
_fc_props.alerts = 'Teavitused';
_fc_props.critical = 'Kriitiline';
_fc_props.important = 'Oluline';
_fc_props.informational = 'Informatiivne';
_fc_props.customer = 'Klient';
_fc_props.view_routes = 'Vaata marsruute';
_fc_props.hours_size = 'Tundide suurus';
_fc_props.used_count = 'Kasutatud arv';
_fc_props.last_login = 'Viimane sisselogimine';
_fc_props.last_vehicle = 'Viimane sõiduk';
_fc_props.regions = 'Piirkonnad';
_fc_props.employee_type = 'Töötaja tüüp';
_fc_props.driver = 'Juht';
_fc_props.js_delete = 'Kustuta';
_fc_props.move = 'Liigu';
_fc_props.edit_hotspot = 'Muuda leviala';
_fc_props.adjust_shape = 'Kuju reguleerimine';
_fc_props.edit_region = 'Redigeeri piirkonda';
_fc_props.enter_a_start_address = 'Palun sisestage algusaadress';
_fc_props.select_a_start_hotspot = 'Palun vali alguspunkt';
_fc_props.failed_to_find_start_hotspot = 'Alguspunkti leviala leidmine ebaõnnestus.';
_fc_props.invalid_latitudelongitude = 'Sobimatu laius-/pikkuskraad';
_fc_props.enter_an_end_address = 'Palun sisestage lõpp-aadress';
_fc_props.select_an_end_hotspot = 'Palun valige lõpp-leviala';
_fc_props.failed_to_find_end_hotspot = 'Lõpp-leviala leidmine ebaõnnestus.';
_fc_props.print = 'Prindi';
_fc_props.these_directions_are_for_informational_purposes = 'Need juhised on ainult informatiivsel eesmärgil. Nende täielikkust ega täpsust ei garanteerita. Ehitusprojektid, liiklus või muud sündmused võivad tegelikke olusid neist tulemustest erineda.';
_fc_props.enter_an_address = 'Palun sisesta aadress';
_fc_props.select_a_hotspot = 'Palun vali leviala';
_fc_props.failed_to_find_hotspot = 'Leviala leidmine ebaõnnestus.';
_fc_props.select_a_vehicle = 'Palun valige sõiduk';
_fc_props.failed_to_find_vehicle = 'Sõidukit ei leitud.';
_fc_props.failed_to_find_address = 'Aadressi leidmine ebaõnnestus';
_fc_props.failed_to_find_vehicles = 'Otsingukriteeriumidest ei leitud sõidukeid.';
_fc_props.get_address = 'Hangi aadress';
_fc_props.results_for = 'Tulemused päringule';
_fc_props.error_retrieving_results = 'Viga tulemuste toomisel';
_fc_props.no_results_found = 'Tulemusi ei leitud';
_fc_props.address_is_required = 'Aadress on kohustuslik';
_fc_props.city_is_required = 'Linn on kohustuslik';
_fc_props.set_location = 'Asukoha määramine';
_fc_props.set_area_of_interest = 'Määra huviala';
_fc_props.center_map_here = 'Keskenda kaarti siia';
_fc_props.zoom_to_street_level = 'Suumi tänavatasemele';
_fc_props.set_start = 'Määra algus';
_fc_props.set_end = 'Määra lõpp';
_fc_props.delete_node = 'Kustuta sõlm';
_fc_props.create_a_hotspot = 'Loo leviala';
_fc_props.create_a_region = 'Loo piirkond';
_fc_props.toggle_shapes = 'Kujundite vahetamine/sulgemine';
_fc_props.refresh_map = 'Värskenda kaarti';
_fc_props.more_options = 'Rohkem valikuid';
_fc_props.recenter_map = 'Keskenda kaarti';
_fc_props.zoom_to_vehicle = 'Suumi sõidukile';
_fc_props.apply_filters = 'Rakenda filtreid';
_fc_props.grid_view = 'Ruudustikuvaade';
_fc_props.list_view = 'Loendivaade';
_fc_props.click_to_sort = 'Klõpsake sortimiseks';
_fc_props.message_history = 'Sõnumite ajalugu';
_fc_props.equipment_types = 'Seadmete tüübid';
_fc_props.send_message = 'Saada sõnum';
_fc_props.last_load = 'Viimane laadimine';
_fc_props.last_load_on = 'Viimane laadimine';
_fc_props.manual_logout = 'Käsitsi väljalogimine';
_fc_props.manual_login = 'Käsitsi sisselogimine';
_fc_props.no_employees_logged_in = 'Ühtegi töötajat pole sisse logitud';
_fc_props.select_phone = 'Valige telefon';
_fc_props.you_must_select_a_phone = 'Peate valima telefoni, seadme ja töötaja';
_fc_props.are_you_sure_you_want_to_logout = 'Kas oled kindel, et soovid välja logida?';
_fc_props.fix_time = 'Fikseeritud aeg';
_fc_props.to_next_fix = 'järgmise paranduseni';
_fc_props.minutes_to_next_fix = 'Minutid järgmise paranduseni';
_fc_props.liters = 'Liitrid';
_fc_props.destination = 'Sihtkoht';
_fc_props.return = 'Tagasi';
_fc_props.product = 'Toode';
_fc_props.no_records_found = 'Kirjeid ei leitud.';
_fc_props.vehicle_type = 'Sõiduki tüüp';
_fc_props.view_in_map = 'Kuva kõik kaardil';
_fc_props.uploads = 'Üleslaadimised';
_fc_props.upload_csv_file = 'Laadi üles CSV-fail';
_fc_props.permanent = 'Püsiv';
_fc_props.expire_time = 'Aegumisaeg';
_fc_props.please_select_x_for_tickets_marked_active = 'AKTIIVSEKS märgitud piletite puhul valige palun {0}';
_fc_props.multiple_tickets_marked_active_for_same_x = 'Mitu piletit on märgitud AKTIIVSEKS sama {0} jaoks';
_fc_props.delivery_time = 'Tarneaeg';
_fc_props.failure_connecting_to_servlet = 'Servletiga ühenduse loomisel tekkis tõrge.';
_fc_props.status_time_summary = 'Staatus Aeg Kokkuvõte';
_fc_props.view_in_map_one = 'Kuva kaardil';
_fc_props.question_report = 'Küsimuste aruanne';
_fc_props.end_date = 'Lõppkuupäev';
_fc_props.trailer_number = 'Haagise number';
_fc_props.region_panel = 'Piirkonna paneel';
_fc_props.hotspot_panel = 'Leviala paneel';
_fc_props.shape = 'Kuju';
_fc_props.circle = 'Ring';
_fc_props.polygon = 'Polügoon';
_fc_props.click_the_map_to_set_the_location = 'Soovitud asukoha määramiseks klõpsake kaardil.';
_fc_props.click_the_map_to_set_the_hotspot_center = 'Klõpsa kaardil, et määrata leviala keskpunkt.';
_fc_props.click_the_map_to_set_the_region_center = 'Piirkonna keskpunkti määramiseks klõpsake kaardil.';
_fc_props.click_and_drag_points = 'Kuju muutmiseks klõpsake ja lohistage punkte. Muudatuste salvestamiseks klõpsake nuppu SALVESTA.';
_fc_props.size = 'Suurus';
_fc_props.are_you_sure_you_want_to_move_this = 'Kas oled kindel, et tahad seda teisaldada?';
_fc_props.are_you_sure_you_want_to_delete_this = 'Kas oled kindel, et soovid selle kustutada?';
_fc_props.please_enter_a_valid_size = 'Palun sisestage kehtiv suurus';
_fc_props.failed_to_save = 'Salvestamine ebaõnnestus.';
_fc_props.failed_to_move = 'Liikumine ebaõnnestus.';
_fc_props.failed_to_delete = 'Kustutamine ebaõnnestus.';
_fc_props.x_hours = '{0} tundi';
_fc_props.hide_hotspots = 'Peida levialad';
_fc_props.show_regions = 'Näita piirkondi';
_fc_props.show_hotspots = 'Näita levialasid';
_fc_props.hide_regions = 'Peida piirkonnad';
_fc_props.numeric = 'Numbriline';
_fc_props.message_type = 'Sõnumi tüüp';
_fc_props.text = 'Tekst';
_fc_props.yes_no = 'Jah/Ei';
_fc_props.responses = 'Vastused';
_fc_props.disabled = 'Puudega';
_fc_props.group_name = 'Grupi nimi';
_fc_props.start_timer = 'Käivita taimer';
_fc_props.stop_timer = 'Peata taimer';
_fc_props.are_you_sure_you_want_to_delete_the_x_format = 'Kas oled kindel, et soovid vormingu \'{0}\' kustutada?';
_fc_props.phone_number = 'Telefoninumber';
_fc_props.interface_pound = 'Liidese nr';
_fc_props.field = 'Väli';
_fc_props.default_label = 'Vaikimisi silt';
_fc_props.custom_label = 'Kohandatud silt';
_fc_props.you_must_enter_a_label = 'Peate sisestama sildi.';
_fc_props.enabled = 'Lubatud';
_fc_props.settings = {};
_fc_props.settings.ticket_integration = 'Piletite integreerimine';
_fc_props.settings.geofence_off_open_hotspots = 'Geofence avatud levialadel';
_fc_props.settings.associate_open_hotspots_wticket = 'Avatud levialade sidusettevõtte piletiga';
_fc_props.settings.allow_geofencing_off_of_open_hotspots_or_only_hotspots_associated_with_drivers_ticket = 'Luba geopiirde kasutamine avatud levialadel või ainult Driver\'s Ticketiga seotud levialadel';
_fc_props.settings.whether_or_not_to_associate_open_hotspots_with_tickets_when_a_vehicle_enters_them = 'Kas siduda avatud levialad piletitega, kui sõiduk sinna siseneb';
_fc_props.settings.void_ticket_without_destination = 'Kehtetu pilet ilma sihtkohata';
_fc_props.settings.if_a_ticket_is_received_while_another_one_is_active_if_the_active_ticket_does = 'Kui pilet saabub ajal, mil teine on aktiivne, ja aktiivsel piletil puudub sihtkoht, siis pilet tühistatakse.';
_fc_props.settings.autocreate_hotspots = 'Loo levialad automaatselt';
_fc_props.settings.whether_or_not_to_automatically_create_hotspots_from_the_destination = 'Kas pileti saabumisel luua sihtkoha aadressist automaatselt levialad või mitte';
_fc_props.settings.autoactivate_ticket_upon_receive = 'Pileti automaatne aktiveerimine kättesaamisel';
_fc_props.settings.is_the_ticket_active_when_it_is_received_by_trackit_default_true = 'Kas pilet on aktiivne, kui TrackIt selle vastu võtab (vaikimisi \'true\')';
_fc_props.settings.auto_close_active_ticket_upon_receive_minutes = 'Aktiivse pileti automaatne sulgemine minutite saabumisel';
_fc_props.settings.how_long_does_the_current_active_ticket_need_to_have_been_active_before = 'Kui kaua peab praegune aktiivne pilet olema aktiivne enne automaatset sulgemist (vaikimisi \'\')';
_fc_props.settings.ticket_max_activate_age_minutes = 'Pileti maksimaalne aktiveerimisaeg minutites';
_fc_props.settings.how_old_in_minutes_can_a_ticket_be_when_activating_it_in_trackit_default_ = 'Kui vana minutites võib pilet olla TrackItis aktiveerimisel (vaikimisi \'\')';
_fc_props.settings.max_hotspot_unused_days = 'Maksimaalne leviala kasutamata päevade arv';
_fc_props.settings.sets_the_max_days_a_hotspot_can_be_unused_and_still_be_revived = 'Määrab maksimaalse päevade arvu, mille jooksul leviala saab kasutamata olla ja ikkagi taaselustada.';
_fc_props.settings.radius_multiplier = 'Raadiuse kordaja';
_fc_props.settings.what_to_multiply_the_radius_by_when_a_ticket_is_received_from_the = 'Millega korrutada raadiust, kui dispetšerisüsteemist saabub pilet?';
_fc_props.settings.ticket_message_date_format = 'Piletiteate kuupäeva vorming';
_fc_props.am = 'olen';
_fc_props.pm = 'pärastlõunal';
_fc_props.settings.ticket_message = 'Piletiteade';
_fc_props.settings.add_ticket_element = 'Lisa piletielement';
_fc_props.driver_performance = 'Juhi sooritusvõime';
_fc_props.update_failed_can_not_connect = 'Värskendamine ebaõnnestus: Servletiga ei saa ühendust luua.';
_fc_props.company = 'Ettevõte';
_fc_props.unknown_error = 'Tundmatu viga';
_fc_props.selected = 'Valitud';
_fc_props.web_service = 'Veebiteenus';
_fc_props.error_processing_request = 'Viga päringu töötlemisel.';
_fc_props.email_address = 'E-posti aadress';
_fc_props.id = 'ID-kaart';
_fc_props.last_used = 'Viimati kasutatud';
_fc_props.error_invalid_vehiclenum = 'Viga Kehtetu sõidukinumber';
_fc_props.error_vehicle_is_not_logged_in = 'Viga: Sõiduk pole sisse logitud.';
_fc_props.status_timer = 'Oleku taimer';
_fc_props.warning = 'Hoiatus';
_fc_props.users = 'Kasutajad';
_fc_props.you_dont_have_access_to_this_page = 'Teil pole selle lehe vaatamiseks juurdepääsu. Juurdepääsu saamiseks võtke ühendust oma süsteemiadministraatoriga.';
_fc_props.previous_week = 'Eelmine nädal';
_fc_props.status_breakdown = 'Staatuse jaotus';
_fc_props.select_plant_or_employee_group = 'Peate valima kas tehase või töötajate rühma.';
_fc_props.cannot_select_plant_and_employee_group = 'Te ei saa valida nii tehast kui ka töötajate gruppi.';
_fc_props.odometer_must_be_a_number = 'Algne odomeetri näit peab olema number';
_fc_props.ending_odometer_must_be_a_number = 'Lõpp-odomeetri näit peab olema number';
_fc_props.beginning_hour_meter_must_be_a_number = 'Alguses olev töötundide loendur peab olema number';
_fc_props.ending_hour_meter_must_be_a_number = 'Lõpptunniloendur peab olema number';
_fc_props.error_loading_status_change_page = 'Viga oleku muutmise lehe laadimisel.';
_fc_props.x_is_an_invalid_time_format = '{0} on sobimatu kellaajavorming, see peab olema AAAA-KK-PP HH:MM:SS';
_fc_props.x_for_schedule_login = '{0} ajastatud sisselogimise jaoks';
_fc_props.x_for_schedule_logout = '{0} väljalogimise ajakava jaoks';
_fc_props.x_for_actual_login = '{0} tegeliku sisselogimise jaoks';
_fc_props.x_for_actual_logout = '{0} tegeliku väljalogimise jaoks';
_fc_props.by_refreshing_the_time_card_detail = 'Ajakaardi andmete värskendamisel kaotate kõik muudatused, kas jätkata?';
_fc_props.are_you_sure_you_want_to_delete_0 = 'Kas oled kindel, et soovid {0} kustutada?';
_fc_props.settings.command_mobile_ticket_url = 'Käskluse mobiilse pileti URL';
_fc_props.year = 'Aasta';
_fc_props.make = 'Tee';
_fc_props.model = 'Mudel';
_fc_props.settings.command_mobile_ticket_password = 'Commandi mobiilse pileti parool';
_fc_props.settings.command_mobile_ticket_auth_token = 'Commandi mobiilse pileti autentimisluba';
_fc_props.target = 'Sihtmärk';
_fc_props.number_of_digits = 'Numbrite arv';
_fc_props.number_of_integer_digits = 'Täisarvude arv';
_fc_props.number_of_fractional_digits = 'Murdarvude arv';
_fc_props.search = 'Otsi';
_fc_props.settings.command_mobile_ticket_date_order = 'Command Mobile\'i pileti kuupäeva tellimine';
_fc_props.settings.command_mobile_ticket_date_length = 'Command Mobile\'i pileti kuupäeva pikkus';
_fc_props.settings.command_mobile_ticket_date_separator = 'Command Mobile\'i pileti kuupäeva eraldaja';
_fc_props.settings.command_mobile_ticket_slash = '/ (kaldkriips)';
_fc_props.settings.command_mobile_ticket_dash = '- (kriips)';
_fc_props.settings.command_mobile_ticket_period = '. (punkt)';
_fc_props.settings.command_mobile_ticket_space = '(tühik)';
_fc_props.settings.command_mobile_ticket_time_length = 'Command Mobile\'i pileti ajapikkus';
_fc_props.settings.command_mobile_ticket_time_separator = 'Command Mobile\'i piletite aja eraldaja';
_fc_props.settings.command_mobile_ticket_colon = ': (koolon)';
_fc_props.settings.command_mobile_ticket_time_format = 'Command Mobile\'i pileti ajavorming';
_fc_props.settings.command_mobile_ticket_use_interface_number = 'Kasutage liidese numbrit';
_fc_props.language = 'Keel';
_fc_props.mechanic = 'Mehaanik';
_fc_props.settings.command_mobile_ticket_poll_interval = 'Küsitluse intervall (sekundites)';
_fc_props.driving_time = 'Sõiduaeg';
_fc_props.find_near_plants = 'Leia lähedalasuvaid taimi';
_fc_props.please_create_hot_spot_first = 'Palun loo esmalt leviala';
_fc_props.pump = 'Pump';
_fc_props.please_enter_hot_spot_description = 'Palun sisestage leviala kirjeldus';
_fc_props.please_select_a_hot_spot_type = 'Palun vali leviala tüüp';
_fc_props.settings.command_mobile_ticket_send_driver_email = 'Saada juhile e-kiri';
_fc_props.directions_not_found = 'Kehtetu aadress {0}. Juhiseid ei leitud.';
_fc_props.ws_user = 'Kasutaja';
_fc_props.ws_service = 'Teenindus';
_fc_props.ws_method = 'Meetod';
_fc_props.ws_params = 'Parameetrid';
_fc_props.units_kilometers_abbr = 'KM';
_fc_props.units_miles_abbr = 'MI';
_fc_props.origin_and_destination = 'Lähte- ja sihtkoht';
_fc_props.liter_abbr = 'l';
_fc_props.help = 'Abi';
_fc_props.settings.command_mobile_ticket_use_alt_emp_number = 'Android kasutab alternatiivset töötajanumbrit';
_fc_props.settings.command_mobile_ticket_android_url = 'Androidi mobiilipileti URL';
_fc_props.settings.command_mobile_ticket_android_secret = 'Androidi mobiilipileti saladus';
_fc_props.employee_x_has_no_logout_on_y = 'Töötajal {0} puudub väljalogimine vahetusest, mis algab {1}.';
_fc_props.phone_number_has_duplicates = 'Telefoninumbritel on topeltkirjeid';
_fc_props.ounce = 'Unts';
_fc_props.water_extra = 'Vesi Extra';
_fc_props.always = 'Alati';
_fc_props.work_types_must_be_unique = 'Töötüübid peavad olema unikaalsed';
_fc_props.manufacturer = 'Tootja';
_fc_props.need_to_enter_seconds = 'Vaja sisestada sekundid.';
_fc_props.copy = 'Kopeeri';
_fc_props.create_in_existing_required = 'Rändluspääsupunkti loomiseks peab olema valitud suvand „Loo olemasolevasse”.';
_fc_props.break = 'Paus';
_fc_props.add_export_data_type = 'Lisa ekspordi andmetüüp';
_fc_props.edit_export_data_type = 'Redigeeri eksporditud andmetüüpi';
_fc_props.delete_export_data_type = 'Kustuta eksporditud andmetüüp';
_fc_props.export_data_type = 'Ekspordi andmetüüp';
_fc_props.error_updating_export_data_type = 'Ekspordi andmetüübi värskendamise viga';
_fc_props.settings.address_key = 'Aadressivõti';
_fc_props.settings.address_key_hover = 'Aadressivõtme valikud';
_fc_props.settings.address_key_options = 'Aadressivõtme valikud';
_fc_props.more_filter_options = 'Rohkem filtreerimisvalikuid';
_fc_props.unauthorized_mapit_app = 'See MapIti versioon pole autoriseeritud, palun uuenda MapIti nii kiiresti kui võimalik.';
_fc_props.zello_timeout = 'Zelloga ühenduse loomisel tekkis ajalõpp.';
_fc_props.user_agreement_text = 'Sisse logides nõustute tingimustega';
_fc_props.user_agreement = 'kasutajaleping';
_fc_props.upload = 'Laadi üles';
_fc_props.x_mins_left = '{0} minutit jäänud';
_fc_props.continuous_location_tracking_colon = 'Pidev asukoha jälgimine:';
_fc_props.hired_hauler_cannot_register_device = 'Palgatud vedaja ei saa uut seadet registreerida.';
_fc_props.timecard_does_not_contain_shift = 'Töötaja ajakaart ei sisalda sisestatud vahetust (ajakaardi infot)';
_fc_props.timecard_not_found = 'Töötaja ajakaarti ei leitud';
_fc_props.vehicle_must_be_assigned_for_clt = 'Sõiduk tuleb määrata rööbastee asukohtadele.';
_fc_props.vehicle_unassigned_continuous_tracking_disabled = 'Sõidukilt eemaldati pidev jälgimine ja see keelatakse.';
_fc_props.units_yards_abbr = 'Aasta';
_fc_props.units_meters_abbr = 'M';
_fc_props.error_lost_edc_connection = 'Telemaatikaseadmega ühendus katkes. Palun kontrollige, kas WiFi ja/või Bluetooth on lubatud.';
_fc_props.acknowledge_all = 'Tunnista kõiki';
_fc_props.expand = 'Laienda';
_fc_props.collapse = 'Kokkuvarisemine';
_fc_props.expand_all = 'Laienda kõiki';
_fc_props.collapse_all = 'Ahenda kõik';
_fc_props.last_update = 'Viimane uuendus';
_fc_props.acknowledge_alert = 'Hoiatuse kinnitamine';
_fc_props.acknowledge_message = 'Sõnumi kinnitamine';
_fc_props.acknowledge_all_alerts = 'Kinnita kõik hoiatused';
_fc_props.acknowledge_all_messages = 'Kinnita kõik sõnumid';
_fc_props.eta = 'Eeldatav saabumisaeg';
_fc_props.tolerance_must_be_a_valid_integer = 'Tolerants peab olema kehtiv täisarv vahemikus -99 kuni 99 (mõlemad kaasa arvatud)';
_fc_props.gps_permission_required = 'GPS-i luba on vajalik';
_fc_props.permissions_required = 'Nõutavad load';
_fc_props.change_user = 'Muuda kasutajat';
_fc_props.account_not_registered_with_carrier = 'See konto pole operaatori juures registreeritud';
_fc_props.slump_loss = 'Madallangus';
_fc_props.slump_loss_help = 'Abi majanduslanguse korral';
_fc_props.did_not_receive_any_edc_devices = 'Ei saanud ühtegi seadet kätte.';
_fc_props.edc_record_not_found = 'Telemaatikaseadme kirjet ei leitud';
_fc_props.disable_hotspot_prompt = 'Kui küsitakse leviala keelamist, puudutage palun nuppu „OK“.';
_fc_props.edc_device_is_in_use = 'Telemaatikaseade {0} on kasutusel.';
_fc_props.an_unknown_exception_has_occurred = 'Tundmatu erand on tekkinud';
_fc_props.login_has_timed_out = 'Sisselogimine on aegunud';
_fc_props.use_paper_logs = 'Kasutage paberlogisid';
_fc_props.eld_login_failed = 'Teenindusaegade sisselogimine ebaõnnestus';
_fc_props.setup_time_off_type = 'Palun määrake vaba aja tüüp.';
_fc_props.view_load_properties = 'Vaate laadimise omadused';
_fc_props.couldnt_download_edc_firmware = 'Telemaatikaseadme püsivara allalaadimine ebaõnnestus.';
_fc_props.password_incorrect = 'Parool on vale';
_fc_props.edc_configuration_password_prompt = 'Selle seadme oleku tõttu peate konfigureerimiseks sisestama paigaldaja parooli.';
_fc_props.edc_configuration_check_failed = 'Telemaatikaseadme serveri kirjete valideerimine ebaõnnestus. Lisateabe saamiseks vaadake veateateid.';
_fc_props.configuration_issues_prompt = 'Valitud telemaatikaseadme konfigureerimisel määratud veoauto jaoks tuvastati järgmised probleemid.';
_fc_props.checking_password = 'Parooli kontrollimine';
_fc_props.reset_password_instructions_sent = 'Parooli lähtestamise juhised saadeti e-posti aadressile {0}.';
_fc_props.reset_password_failed = 'Parooli lähtestamine ebaõnnestus, proovige uuesti.';
_fc_props.forgot_password = 'Unustasid parooli?';
_fc_props.enter_valid_email = 'Kehtetu e-posti aadress, palun sisestage kehtiv e-posti aadress ja proovige uuesti.';
_fc_props.issues_while_updating_edc_record = 'Telemaatikaseade konfigureeriti edukalt. TrackIt serveris on aga seadme kirjetega probleeme, mis võivad põhjustada seadme mittetoimimist. Teabe parandamiseks võtke ühendust toega.';
_fc_props.sending = 'Saadetakse...';
_fc_props.minimum_ratio = 'Minimaalne suhe';
_fc_props.vin = 'VIN-kood';
_fc_props.probe_rpm_not_in_range = 'Trumli pöörete arv pole vahemikus';
_fc_props.probe_failure = 'Sondi rike';
_fc_props.unknown_probe_data_failure = 'Tundmatu sondi andmete tõrge';
_fc_props.no_loaded_status_meaning = 'Laadimata olek';
_fc_props.no_depart_status_meaning = 'Väljumisstaatuse puudumine';
_fc_props.no_arrive_status_meaning = 'Saabumisstaatuse puudumine';
_fc_props.no_begin_work_status_meaning = 'Töö alustamise staatus puudub';
_fc_props.no_fully_mixed_status_meaning = 'Täielikult segatud staatus puudub';
_fc_props.no_begin_work_or_at_job_status = 'Tööle asumise või töö juures olekut pole';
_fc_props.driver_didnt_follow_procedure = 'Juht ei järginud protseduuri (ei aeglustanud trummi)';
_fc_props.probe_malfunction = 'Sondi rike (sisemine rike jne)';
_fc_props.no_data_from_probe = 'Sondilt pole andmeid (andmete kadu)';
_fc_props.missing_probe_calibration = 'Sondi kalibreerimisandmed puuduvad';
_fc_props.probe_pressure_not_in_range = 'Sondi rõhk ei ole vahemikus';
_fc_props.arrival = 'Saabumine';
_fc_props.small_load = 'VÄIKE KOORMUS';
_fc_props.dry_slump = 'KUIV LANGUS';
_fc_props.probe_remixing_turns = 'Remiksimine';
_fc_props.turns_needed_to_remix = 'Lisatud vesi - vaja on täiendavat segamist';
_fc_props.probe_remixing_finished = 'Remiksimine lõpetatud';
_fc_props.probe_battery_low_alert = 'Sondi aku tühjenemise hoiatus';
_fc_props.probe_battery_low_message = 'Sondi aku tühjeneb';
_fc_props.probe_battery_low = 'Sondi aku tühjeneb';
_fc_props.alert_when_probe_battery_low = 'Hoiatus sondi aku tühjenemise korral';
_fc_props.probe_sensor_fatal_failure = 'Anduri saatuslik rike';
_fc_props.probe_thermistor_failure = 'Termistori rike';
_fc_props.probe_sensor_stuck_in_concrete = 'Betooni kinni jäänud andur';
_fc_props.probe_sensor_over_weight = 'Andur ülekaaluline';
_fc_props.probe_batteries_low = 'Aku on tühi';
_fc_props.no_probe_data = 'Sondi andmed puuduvad:';
_fc_props.check_probe = 'Kontrollige sondi';
_fc_props.service_probe = 'Teenindussond';
_fc_props.below_x = 'Alla {0}';
_fc_props.above_x = 'Üle {0}';
_fc_props.probe_serial_number_invalid_format = 'Sondi seerianumber ei ole välja kohatäite kuvatavas vormingus.';
_fc_props.talk_dnd_permission_prompt = 'Vestluseks on vaja luba MITTE HÄIRIDA.';
_fc_props.max = 'Maks';
_fc_props.status_changed_quickly = 'Staatus muutus liiga kiiresti';
_fc_props.is_empty = 'On tühi';
_fc_props.slump_increased_plasticizer_question = 'Kas plastifikaatorit lisati?';
_fc_props.slump_increased_water_added_question = 'Kui palju mõõtmata vett lisati?';
_fc_props.probe_and_drs_are_not_support_together_on_the_same_device = 'Sondi ja manustamistsükli jälgimist ei toetata samal seadmel koos.';
_fc_props.no_data_from_sensor = 'Andurilt pole andmeid (andmete kadu)';
_fc_props.dvir = 'DVIR';
_fc_props.system_type = 'Süsteemi tüüp';
_fc_props.magnet_count = 'Magnetite arv';
_fc_props.sensors_setup = 'Andurite seadistamine';
_fc_props.drs_requires_io_mac_sensor_drum_type_magnet_count = 'DCM nõuab sisend-/väljundkasti MAC-aadressi, trumli tüübi, DCM-i tüübi ja magnetite arvu seadistamist.';
_fc_props.drs = 'DCM';
_fc_props.drs_ticketed_volume = 'Piletiga hõlmatud maht';
_fc_props.drs_current_volume = 'Praegune maht';
_fc_props.drs_current_water_cement_ratio = 'Praegune vee/tsemendi suhe';
_fc_props.drs_target_water_cement_ratio = 'Sihtväärtuslik vee/tsemendi suhe';
_fc_props.drs_total_revolutions = 'Kokku';
_fc_props.drs_current_volume_lp_small = 'Praegune';
_fc_props.drum_revolutions = 'Trummirevolutsioonid';
_fc_props.drs_total_revolutions_lp_small = 'Kokku';
_fc_props.drs_charging_revolutions_lp_small = 'Laadimine';
_fc_props.drs_discharging_revolutions_lp_small = 'Tühjendamine';
_fc_props.drs_target_wc_lp_small = 'Sihtkoha vihmavari';
_fc_props.drs_current_wc_lp_small = 'Praegune nädalavahetus';
_fc_props.drs_ticketed_volume_lp_small = 'Piletiga';
_fc_props.android_location_disclosure = 'TrackIt kasutab täpseid ja ligikaudseid asukohaandmeid taustal isegi siis, kui seadet ei kasutata, et võimaldada automaatset oleku määramist ja reaalajas kaardi nähtavust dispetšeri jaoks.';
_fc_props.android_location_usage = 'Asukoha avalikustamine';
_fc_props.end_pour_trigger_threshold = 'Lõppvalamise käivituslävi';
_fc_props.drs_wiring_error = 'Juhtmestiku viga';
_fc_props.drs_wiring_pulse_error = 'Juhtmestiku impulsi viga';
_fc_props.drs_wiring_magnet_error = 'Juhtmestiku magneti viga';
_fc_props.drs_magnet_missing_error = 'Magneti puudumise viga';
_fc_props.android_location_disclosure_3p = 'TrackIt kogub taustal asukohaandmeid, et võimaldada automaatset staatuse määramist ja reaalajas kaardi nähtavust lähetuse jaoks. Kui saatja on saatmise ajal kellaajast väljunud, siis asukohta ei jagata.';
_fc_props.please_select_either_fullmdm_or_trackit_remote_support = 'Palun valige kas täielik MDM või Trackiti kaugtugi';
_fc_props.move_up = 'Liiguta üles';
_fc_props.move_down = 'Liiguta alla';
_fc_props.driver_not_found = 'Draiverit ei leitud.';
_fc_props.multiple = 'Mitmekordne';
_fc_props.water_meter_installed = 'Veemõõtja paigaldatud';
_fc_props.delete_waypoint = 'Kustuta teekonnapunkt';
_fc_props.wash_sensor_installed = 'Pesuandur on paigaldatud';
_fc_props.washing_start_time = 'Pesemise algusaeg';
_fc_props.end_washing = 'Pesu lõpp';
_fc_props.variable_rpms = 'Muutujate RPM-id';
_fc_props.no_slump = 'Madalseisu pole';
_fc_props.end_washing_duration = 'Pesu lõpp-kestus';
_fc_props.privacy_policy = 'Privaatsuspoliitika';
_fc_props.privacy_policy_text = 'Olen lugenud ja nõustun tingimustega';
_fc_props.login_fail_accept_privacy_policy = 'Jätkamiseks tuleb privaatsuspoliitikaga nõustuda.';
_fc_props.rotation_sensor = 'Pöörlemisandur';
_fc_props.pto_sensor = 'Jõuvõtuvõlli andur';
_fc_props.pto_sensor_installed = 'PTO andur on paigaldatud';
_fc_props.polarity_reversed = 'Pöördpolaarsus';
_fc_props.pto_sensor_type = 'Jõuvõtuvõlli anduri tüüp';
_fc_props.sensor_type = 'Anduri tüüp';
_fc_props.prompt_select_pto_sensor_type = 'Kui olete peamiseks anduri tüübiks valinud "Jooksuvõlli anduri", peate valima "Jooksuvõlli anduri tüübi".';
_fc_props.priming_turns_at_full_load = 'Täiskoormusel käivitub sissepritse';
_fc_props.priming_turns_at_ten_percent_load = 'Sissepritse pöörded 10% koormusel';
_fc_props.weight_units = 'Kaaluühikud';
_fc_props.settings.send_status = 'Saada olek/asukoht Event Bridge\'i';
_fc_props.volume_difference = 'Mahtude erinevus';
_fc_props.mobile_ticket_iframe_url = 'Mobiilipileti IFrame\'i URL';
_fc_props.mobile_ticket_user = 'Mobiilse pileti kasutaja';
_fc_props.mobile_ticket_password = 'Mobiilse pileti parool';
_fc_props.current_truck_status = 'Veoauto praegune olek';
_fc_props.estimated_symbol = '℮';
_fc_props.almost_equal_to_symbol = '≈';
_fc_props.triggered_by_max_revolutions = 'Maksimaalsete pöörete poolt käivitatav';
_fc_props.alerts_by_type = 'Teavitused tüübi järgi';
_fc_props.water_flow_meter = 'Veevoolumõõtur';
_fc_props.flow_meter_no_pulses_warning = 'Pulsside puudumine - hoiatus';
_fc_props.flow_meter_no_pulses_critical = 'Pulsside puudumine - kriitiline';
_fc_props.flow_meter_excessive_pulses = 'Liigne pulss';
_fc_props.flow_meter_constantly_flowing = 'Pidevalt voolav';
_fc_props.flow_meter_good = 'Hea';
_fc_props.whats_new = 'Mis on uut?';
_fc_props.whats_new_widget_text = 'Kas teadsite, et me uuendame TrackIti vähemalt kord kuus? Hankige uusimad värskendused ja näpunäited.';
_fc_props.get_the_scoop = 'Saage teada';
_fc_props.trackit_insights = 'Trackit Insights';
_fc_props.business_analytics_blurb = 'Ärianalüütika, mis parandab teie lõpptulemust, on nüüd TrackIti komplektis';
_fc_props.find_out_more = 'Lisateave';
_fc_props.daily_breakdown = 'Päevane jaotus';
_fc_props.question_summary = 'Küsimuse kokkuvõte';
_fc_props.trip_summary = 'Reisi kokkuvõte';
_fc_props.manage_employees = 'Töötajate haldamine';
_fc_props.manage_hotspots = 'Halda levialasid';
_fc_props.manage_devices = 'Seadmete haldamine';
_fc_props.manage_equipment = 'Seadmete haldamine';
_fc_props.manage_users = 'Kasutajate haldamine';
_fc_props.manage_statuses = 'Halda staatuseid';
_fc_props.manage_alerts = 'Halda märguandeid';
_fc_props.popular_report_links = 'Populaarsed aruannete lingid';
_fc_props.popular_settings_links = 'Populaarsete seadete lingid';
_fc_props.sidemenu_settings = 'Seaded';
_fc_props.loads_per_driver = 'Koormusi juhi kohta';
_fc_props.please_select_application = 'Palun vali vähemalt üks rakendus';
_fc_props.external_app_processing = 'Töötlemine välises rakenduses';
_fc_props.external_app_sent = 'Saadetud välisele rakendusele';
_fc_props.external_app_received = 'Välise rakenduse poolt vastu võetud';
_fc_props.wait_time_at_job = 'Ooteaeg töökohal';
_fc_props.wait_time_at_plant = 'Ooteaeg tehases';
_fc_props.loading_time = 'Laadimisaeg';
_fc_props.unloading_time = 'Mahalaadimisaeg';
_fc_props.pre_post_trip = 'Enne/pärast reisi';
_fc_props.update_thresholds = 'Värskendusläved';
_fc_props.green = 'Roheline';
_fc_props.yellow = 'Kollane';
_fc_props.red = 'Punane';
_fc_props.between = 'Vahel';
_fc_props.num_of_loads = 'Koormade arv';
_fc_props.num_of_drivers = 'Juhtide arv';
_fc_props.status_meaning_not_setup = 'Staatus Tähendus pole seadistatud';
_fc_props.or_less = 'Või vähem';
_fc_props.or_greater = 'Või suurem';
_fc_props.probe_self_diagnostic_state = 'Sondi enesediagnostika olek';
_fc_props.update_current_truck_status_settings = 'Värskenda praeguse veoauto oleku seadeid';
_fc_props.default_behavior = 'Vaikimisi (10 populaarseimat olekut)';
_fc_props.combine_similar_statuses = 'Kombineeri samad staatused kõigist tüüpidest (tsüklid)';
_fc_props.use_other_category = 'Kasuta kategooriat „Muu”';
_fc_props.selected_statuses = 'Valitud staatused';
_fc_props.ideas = 'Ideed';
_fc_props.air_content = 'Õhusisaldus';
_fc_props.air_measured_time = 'Õhus mõõdetud aeg';
_fc_props.ten_max = '10 maksimaalselt';
_fc_props.loads_per_plant = 'Koormused taime kohta';
_fc_props.invalid_flow_meter_pulse_per_volume = 'Kehtetu voolumõõturi impulss mahu kohta.';
_fc_props.coming_soon_title = 'Rohkem vidinaid on tulekul';
_fc_props.submit_your_ideas = 'Esitage oma ideed meie ideedeportaali, kasutades vasakpoolses navigeerimismenüüs olevat lambipirni ikooni.';
_fc_props.selected_plants = 'Valitud taimed';
_fc_props.update_loads_per_plant_settings = 'Värskenda koormusi tehase seadete järgi';
_fc_props.default_top_10_plants = 'Vaikimisi (10 parimat taime)';
_fc_props.phone_number_will_be_uploaded = 'Seadme ID laaditakse registreerimise eesmärgil üles.';
_fc_props.include_deleted = 'Lisa kustutatud';
_fc_props.primary_status_type = 'Peamine staatuse tüüp';
_fc_props.additional_status_trigger = 'Täiendavad oleku käivitajad';
_fc_props.update_tickets_destination = 'Värskenda sihtkohta kõigil seotud piletitel';
_fc_props.settings.send_destination_changes_to_connex = 'Saada sihtkoha muudatused Connexile';
_fc_props.settings.is_the_ticket_active_when_it_is_received_by_trackit_default_always = 'Kas pilet on aktiivne, kui TrackIt selle vastu võtab (vaikimisi \'always\')?';
_fc_props.settings.autoactivate_next_ticket_on_ticket_completion = 'Aktiveeri järgmine taotlus eelmise taotluse täitmisel automaatselt';
_fc_props.settings.should_autoactivate_next_ticket_on_ticket_completion_default_true = 'Peaks järgmise pileti automaatselt aktiveerima pileti valmimisel (vaikimisi \'true\')';
_fc_props.settings.status_to_idle_status_when_no_active_ticket = 'Kui aktiivset piletit pole, siis olek jõudeolekusse';
_fc_props.break_down = 'Jaota maha';
_fc_props.idle = 'Jõudeolek';
_fc_props.pto_work_maximum_speed_limit = 'Töö maksimaalne kiirusepiirang';
_fc_props.settings.associate_ticket_to_status_on_complete = 'Pileti staatuse muutmine, mis selle piletiga lõpetab,';
_fc_props.approaching = 'Lähenemas';
_fc_props.performing_task = 'Ülesande täitmine';
_fc_props.are_you_sure_you_want_to_delete_geogate = 'Kas oled kindel, et soovid Geogate\'i {0} kustutada?';
_fc_props.trackit_destination_changed_to_0 = 'Pileti {0} uuendamine. Sihtkoht on muudetud.';
_fc_props.trackit_return_destination_changed_to_0 = 'Pileti {0} uuendamine. Tagastus muudetud.';
_fc_props.menu_settings_title_geogate = 'Geovärav';
_fc_props.add_geogate = 'Lisa geovärav';
_fc_props.driver_enabled = 'Draiver lubatud';
_fc_props.dispatcher_enabled = 'Dispetšer lubatud';
_fc_props.runsheet_number = 'Jooksulehe number';
_fc_props.manual_load = 'Käsitsi laadimine';
_fc_props.delivery = 'Kohaletoimetamine';
_fc_props.return_run = 'Tagasijooks';
_fc_props.home_run = 'Kodujooks';
_fc_props.edit_geogate = 'Redigeeri Geogate\'i';
_fc_props.handling = 'Käitlemine';
_fc_props.geogate_name = 'Geovärav';
_fc_props.geogate_panel = 'Geovärava paneel';
_fc_props.vehicle_is_not_logged_in = 'Sõnumit ei saadetud (sõiduk pole sisse logitud)';
_fc_props.air = 'Õhk';
_fc_props.create_a_geogate = 'Loo geovärav';
_fc_props.click_the_map_to_set_the_geogate_points = 'Geovärava punktide määramiseks klõpsake kaardil.';
_fc_props.clock_out = 'Väljaregistreerimine';
_fc_props.handling_operation = 'Käitlemisoperatsioon';
_fc_props.view_geogates = 'Vaata geoväravaid';
_fc_props.select_a_geogate = 'Palun vali geovärav';
_fc_props.failed_to_find_geogate = 'Geogate\'i leidmine ebaõnnestus';
_fc_props.adjust_geogate = 'Geograafilise värava kohandamine';
_fc_props.geogate_expiration_date_time_extra_days = 'Geogate\'i kehtivusaja lõppkuupäev Kellaaeg Vaikimisi Lisapäevad';
_fc_props.menu_settings_title_retention = 'Andmete säilitamine';
_fc_props.category = 'Kategooria';
_fc_props.telemetry = 'Telemeetria';
_fc_props.ticket_data = 'Piletiandmed';
_fc_props.driver_break = 'Juhi paus';
_fc_props._30_days = '30 päeva';
_fc_props._6_months = '6 kuud';
_fc_props._1_year = '1 aasta';
_fc_props._3_years = '3 aastat';
_fc_props.discharge = 'Tühjendamine';
_fc_props.new_group = 'Uus grupp';
_fc_props.selected_vehicles = 'Valitud sõidukid';
_fc_props.group_name_is_required_field = 'Grupi nime väli on kohustuslik';
_fc_props.at_least_vehicle_should_be_selected = 'Valida tuleks vähemalt üks sõiduk';
_fc_props.groups = 'Grupid';
_fc_props.trucks = 'Veoautod';
_fc_props.geogate_has_been_removed_please_refresh_page = 'Geovärav on eemaldatud. Palun värskenda lehte.';
_fc_props.air_timestamp = 'Eetri ajatempel';
_fc_props.fail = 'EBAÕNNESTUMINE';
_fc_props.stuck = 'KINNI';
_fc_props.dirty = 'RÄPINUD';
_fc_props.driver_breakdown = 'Jaotus';
_fc_props.seasonal = 'Hooajaline';
_fc_props.category_details = 'Kategooria üksikasjad';
_fc_props.alert_events = 'Häireteated';
_fc_props.driver_performance_infractions = 'Juhi sooritusvõime rikkumised';
_fc_props.telemetry_details = 'Asukohaandmed, levialad, aeg levialades, aeg piirkondades, DCM-andmed, sondi andmed, mootori andmed';
_fc_props.ticket_data_details = 'Piletiandmed';
_fc_props.general_details = 'Staatuse muudatused, ajakavad, ajakavad';
_fc_props.wash = 'Pese';
_fc_props.filter_options = 'Filtri valikud';
_fc_props.home_plants = 'Kodutaimed';
_fc_props.delivery_multidrop = 'Mitmekordne kohaletoimetamine';
_fc_props.dcm = 'DCM';
_fc_props.pto_requires_pto_sensor_type_value = 'DCM-i jõuvõtuvõlli jaoks on vaja seadistada jõuvõtuvõlli anduri tüüp.';
_fc_props.invalid_io_box_mac_address = 'Vigane sisend-/väljundkasti MAC-aadress';
_fc_props.access_denied = 'Juurdepääs keelatud';
_fc_props.wash_events = 'Pesemisüritused';
_fc_props.min_speed = 'Minimaalne kiirus';
_fc_props.temperature_change = 'Temperatuuri muutus';
_fc_props.degrees_cap = 'Kraadid';
_fc_props.washout_tracking = 'Väljapesemise jälgimine';
_fc_props.approaching_wash = 'Läheneb pesule';
_fc_props.arrival_wash = 'Saabumispesu';
_fc_props.performing_wash = 'Pesemise teostamine';
_fc_props.wash_complete = 'Pesu lõpetatud';
_fc_props.must_be_positive_or_zero = 'Peab olema positiivne või null!';
_fc_props.min_speed_greater_than_max = 'Minimaalne kiirus peab olema väiksem kui maksimaalne kiirus!';
_fc_props.clock_in = 'Sisselogimine';
_fc_props.mix_water_at_x_to_y_for_t = 'Sega vett kiirusel {0} kuni {1} pööret minutis {2} pöörde jooksul.';
_fc_props.discharge_water_for_x_revolutions = 'Laske vett {0} pööret läbi.';
_fc_props.eod_drum_wash_complete = 'Trumlipesu on lõppenud! <br> Peatage trummel, sond üleval.';
_fc_props.washing_complete = 'Juhendatud läbipesu on lõppenud';
_fc_props.eod_washout_no_data_available = 'Anduri andmed pole saadaval, palun viige pesuprotsess lõpule.';
_fc_props.eod_washout_no_data_available_title = 'Juhendatud väljapesemine pole saadaval';
_fc_props.menu_reports_title_ticket_time_summary = 'Pileti aja kokkuvõte';
_fc_props.menu_reports_description_ticket_time_summary = 'Tellimuse või sõiduki piletiaja teabe vaatamine';
_fc_props.menu_reports_title_summary = 'Kokkuvõte';
_fc_props.menu_reports_title_ticket_summary = 'Pileti kokkuvõte';
_fc_props.menu_reports_description_summary1 = 'Vaadake levialade aja kokkuvõtet';
_fc_props.menu_dispatch_title_main = 'Peamine';
_fc_props.menu_dispatch_title_login_registry = 'Sisselogimise register';
_fc_props.menu_reports_title_main = 'Peamine';
_fc_props.time_management_are_you_sure_you_want_to_delete_export_data_type = 'Kas olete kindel, et soovite selle eksporditud andmetüübi kustutada?';
_fc_props.dvir_status_paper_logs = 'Paberlogid';
_fc_props.menu_reports_title_billing_report = 'Arveldusaruanne';
_fc_props.menu_reports_description_billing_report = 'Arveldusaruanne';
_fc_props.settings_status_to_ticketed_status_on_activate_work = 'Piletiga märgitud staatus töö aktiveerimisel';
_fc_props.settings_status_to_ticketed_status_on_activate_work_default_false = 'Piletiga märgitud staatus töö aktiveerimisel (vaikimisi \'False\')';
_fc_props.status_change_type_drum_rotation_sensor = 'DCM';
_fc_props.settings_connex_eid = 'Connexi EID';
_fc_props.units_weight_pound_label = 'Nael';
_fc_props.units_weight_kilogram_label = 'Kilogrammid';
_fc_props.settings_weight = 'Kaal';
_fc_props.units_pounds = 'Nael';
_fc_props.units_kilograms = 'Kilogrammid';
_fc_props.geo_gate_edit_modal_description = 'Kirjeldus';
_fc_props.geo_gate_edit_modal_start_point = 'Alguspunkt';
_fc_props.geo_gate_edit_modal_end_point = 'Lõpp-punkt';
_fc_props.geo_gate_edit_modal_vehicle_types = 'Seadme tüüp';
_fc_props.geo_gate_edit_modal_heading_south = 'Lõunast põhja';
_fc_props.geo_gate_edit_modal_heading_north = 'Põhjast lõunasse';
_fc_props.geo_gate_edit_modal_driver_message = 'Juhi teade';
_fc_props.geo_gate_edit_modal_dispatcher_message = 'Saatesõnum';
_fc_props.geo_gate_edit_modal_expiration_date_time = 'Aegumiskuupäev ja kellaaeg';
_fc_props.geo_gate_edit_modal_permanent = 'Püsiv';
_fc_props.geo_gate_edit_modal_critical = 'Kriitiline';
_fc_props.geo_gate_edit_modal_error_message_description_empty = 'Geovärava salvestamisel tekkis viga: kirjelduse väli peab olema täidetud.';
_fc_props.geo_gate_edit_modal_error_message_start_point_empty = 'Geovärava salvestamisel tekkis viga: alguspunkti väli peab olema täidetud.';
_fc_props.geo_gate_edit_modal_error_message_start_point_invalid_format = 'Geovärava salvestamisel tekkis viga: alguspunkti väli sisaldab sobimatut andmevormingut.';
_fc_props.geo_gate_edit_modal_error_message_end_point_invalid_format = 'Geovärava salvestamisel tekkis viga: lõpp-punkti väli sisaldab sobimatut andmevormingut.';
_fc_props.geo_gate_edit_modal_error_message_expiration_date_time_empty = 'Geovärava salvestamisel tekkis viga: aegumiskuupäeva ja -kellaaja väli peab olema täidetud.';
_fc_props.geo_gate_edit_modal_error_message_expiration_date_time_invalid_format = 'Geovärava salvestamisel tekkis viga: aegumiskuupäeva ja kellaaja väli sisaldab sobimatut andmevormingut.';
_fc_props.geo_gate_edit_modal_error_message_heading_north_dispatcher_message_empty = 'Geovärava salvestamisel tekkis viga: põhjast lõunasse – väljastussõnumi väli peab olema täidetud';
_fc_props.geo_gate_edit_modal_error_message_no_changes = 'Geogate\'i salvestamisel tekkis viga: muudatusi ei tuvastatud.';
_fc_props.geo_gate_edit_modal_error_message_expiration_date_time_expired = 'Geovärava salvestamisel tekkis viga: aegumiskuupäeva ja -kellaaja väli sisaldab aegunud kuupäeva ja kellaaega.';
_fc_props.geo_gate_edit_modal_error_message_description_invalid_format = 'Geovärava salvestamisel tekkis viga: kirjelduse väli peab sisaldama ainult tähti ja numbreid';
_fc_props.geo_gate_edit_modal_error_message_vehicle_types_empty = 'Geovärava salvestamisel tekkis viga: seadme tüübi väli peab olema täidetud';
_fc_props.geo_gate_table_message_label_north_to_south = 'Põhjast lõunasse';
_fc_props.geo_gate_table_message_label_south_to_north = 'Lõunast põhja';
_fc_props.geo_gate_table_message_label_both = 'Mõlemad';
_fc_props.geo_gate_edit_modal_field_point_tip = 'Laiuskraad, pikkuskraad';
_fc_props.geo_gate_edit_modal_device_movement_message_restriction = 'Selle märkimine tühistab seadme liikumise sõnumipiirangu seadistuse';
_fc_props.geo_gate_edit_modal_seasonal = 'Hooajaline';
_fc_props.geo_gate_edit_modal_error_message_seasonal_empty = 'Geovärava salvestamisel tekkis viga: hooajalised kuupäevad peavad olema täidetud';
_fc_props.geo_gate_edit_modal_error_message_seasonal_invalid_date_format = 'Geovärava salvestamisel tekkis viga: hooajaliste kuupäevade väljad sisaldavad sobimatut andmevormingut';
_fc_props.test_js_test_javascript = 'Testi JavaScripti';
_fc_props.units_miles_per_hour_abbr = 'MPH';
_fc_props.units_kilometers_per_hour_abbr = 'KM/H';
_fc_props.units_kilometers = 'Kilomeetrid';
_fc_props.units_miles = 'Miilid';
_fc_props.units_gallons_abbr = 'GAL';
_fc_props.units_liters_abbr = 'L';
_fc_props.geo_gate_edit_modal_error_message_heading_south_driver_message_empty = 'Geovärava salvestamisel tekkis viga: lõunast põhja suunas – juhi sõnumi väli peab olema täidetud';
_fc_props.geo_gate_edit_modal_error_message_heading_south_dispatcher_message_empty = 'Geovärava salvestamisel tekkis viga: lõunast põhja suunas – väljastussõnumi väli peab olema täidetud';
_fc_props.geo_gate_edit_modal_error_message_heading_north_driver_message_empty = 'Geovärava salvestamisel tekkis viga: põhjast lõunasse – juhi sõnumi väli peab olema täidetud';
_fc_props.geo_gate_heading = 'Pealkiri';
_fc_props.geo_gate_edit_modal_error_message_end_point_empty = 'Geovärava salvestamisel tekkis viga: lõpp-punkti väli peab olema täidetud';
_fc_props.units_mile = 'Miil';
_fc_props.units_kilometer = 'Kilomeeter';
_fc_props.cloud_dvir__exit = 'Väljapääs';
_fc_props.cloud_dvir__signature = 'Allkiri';
_fc_props.cloud_dvir__inspection = 'Kontroll';
_fc_props.cloud_dvir__add_photos_notes = 'Lisa fotosid/märkmeid';
_fc_props.cloud_dvir__odometer_reading = 'Odomeetri näit';
_fc_props.cloud_dvir__engine_hours = 'Mootori töötunnid';
_fc_props.cloud_dvir__truck_details = 'Veoauto üksikasjad';
_fc_props.cloud_dvir__determine_the_overall_condition_of_the_vehicle = 'Määrake sõiduki üldine seisukord';
_fc_props.cloud_dvir__full_name_and_signature_of_driver = 'Juhi täisnimi ja allkiri';
_fc_props.cloud_dvir__sign = 'Märk';
_fc_props.cloud_dvir__driver_note_from = 'Juhi märkus alates';
_fc_props.cloud_dvir__add_notes = 'Lisa märkmeid';
_fc_props.cloud_dvir__driver_notes = 'Juhi märkmed';
_fc_props.cloud_dvir__done = 'Valmis';
_fc_props.cloud_dvir__needs_repair = 'Vajab remonti';
_fc_props.cloud_dvir__not_applicable = 'Ei ole kohaldatav';
_fc_props.cloud_dvir__review_and_sign = 'Vaadake üle ja allkirjastage';
_fc_props.cloud_dvir__add_photos = 'Lisa foto';
_fc_props.cloud_dvir__upload_photo_limit = 'Saate üles laadida kuni 3 pilti';
_fc_props.cloud_dvir__mismatch_title = 'Vastuolu hoiatus';
_fc_props.cloud_dvir__ok = 'Olgu';
_fc_props.cloud_dvir_template = 'Pilve DVIR-i mall';
_fc_props.cloud_dvir__needs_review = 'DVIR vajab ülevaatamist';
_fc_props.cloud_dvir__submitted = 'Esitatud';
_fc_props.cloud_dvir__completed_by = 'Lõpetanud';
_fc_props.cloud_dvir__review_btn = 'Ülevaade';
_fc_props.cloud_dvir__truck_number = 'Veoauto {0}';
_fc_props.cloud_dvir__pending_review = 'Ülevaatuse ootel';
_fc_props.cloud_dvir__start_dvir = 'Käivita DVIR';
_fc_props.cloud_dvir__dvir_history = 'DVIR-i ajalugu';
_fc_props.cloud_dvir__view_all = 'Kuva kõik';
_fc_props.load_zone = 'Koormusvöönd';
_fc_props.view_load_zones = 'Vaata koormustsoone';
_fc_props.edit_load_zone = 'Redigeeri laadimistsooni';
_fc_props.create_a_load_zone = 'Loo koormustsoon';
_fc_props.load_zone_panel = 'Koormusvööndi paneel';
_fc_props.click_the_map_to_set_the_load_zone_center = 'Laadimistsooni keskpunkti määramiseks klõpsake kaardil.';
_fc_props.cloud_dvir__mismatch_title_all_items_ok = 'Sellel ülevaatusel on tuvastatud defekte ja olete otsustanud, et see sõiduk on ohutu kasutada. Palun kinnitage see enne jätkamist.';
_fc_props.cloud_dvir__mismatch_title_needs_repair = 'See kontroll ei tuvastanud mingeid defekte ja olete valinud, et selle sõiduki kasutamine on ohtlik. Palun kinnitage see enne jätkamist.';
_fc_props._90_days = '90 päeva';
_fc_props.cloud_dvir = 'Pilve DVIR';
_fc_props.cloud_dvir_details = 'Pilve DVIR-i esildised';
_fc_props.show_load_zones = 'näita koormustsoone';
_fc_props.hide_load_zones = 'peida laadimistsoonid';
_fc_props.no = 'Ei';
_fc_props.cloud_dvir__reset = 'Lähtesta';
_fc_props.cloud_dvir__clear = 'Selge';
_fc_props.mark_read = 'Mark Read';
_fc_props.mark_unread = 'Märgi lugemata';
_fc_props.read = 'Loe';
_fc_props.unread = 'Lugemata';
_fc_props.air_sensor_serial_number = 'Õhuanduri seerianumber';
_fc_props.air_sensor_mac_address = 'Õhuanduri MAC-aadress';
_fc_props.air_sensor_serial_number_invalid_format = 'Õhusensori seerianumber ei ole sobivas vormingus: (tähtnumbriline ja maksimaalselt 32 tähemärki pikk koos kriipsudega)';
_fc_props.air_sensor_mac_address_invalid_format = 'Õhusensori MAC-aadress ei ole välja kohatäite kuvamisel sobimatus kuueteistkümnendsüsteemis';
_fc_props.air_sensor_license = 'Õhuandur';
_fc_props.adjust_route_point = 'Marsruudipunkti kohandamine';
_fc_props.route_point_panel = 'Marsruudipunktide paneel';
_fc_props.route_point = 'Marsruudipunkt';
_fc_props.cloud_dvir__pre_trip = 'Enne reisi';
_fc_props.cloud_dvir__post_trip = 'Pärast reisi';
_fc_props.cloud_dvir__other_insction_type = 'Muu';
_fc_props.cloud_dvir__dvir_completed = 'Lõpetatud';
_fc_props.cloud_dvir__awaiting_mechanic = 'Ootav mehaanik';
_fc_props.cloud_dvir__awaiting_driver = 'Ootan juhi allkirja';
_fc_props.unable_to_check_air_sensor_serial_number_please_contact_support_for_assistance = 'Õhusensori seerianumbrit ei õnnestunud kontrollida, lisateabe saamiseks võtke ühendust toega.';
_fc_props.this_air_sensor_serial_number_exists_please_use_another_serial_number = 'See õhuanduri seerianumber on juba olemas, palun kasutage teist seerianumbrit';
_fc_props.unable_to_check_air_sensor_mac_address_please_contact_support_for_assistance = 'Õhusensori MAC-aadressi kontrollimine ebaõnnestus, abi saamiseks võtke ühendust toega.';
_fc_props.cloud_dvir__error_submit_dvir_title = 'Viga DVIR-i esitamisel';
_fc_props.cloud_dvir__error_submit_dvir_descr = 'Palun proovige uuesti';
_fc_props.ticket_integration_descr = 'Piletite integreerimine võimaldab määrata piletite integreerimise sätteid, samuti avakuva / laadimiskuva / kõvaketta kuva.';
_fc_props.cloud_dvir__success_submit_dvir_title = 'DVIR edukalt esitatud';
_fc_props.cloud_dvir__inspection_trip_type = 'Kontrollreisi tüüp';
_fc_props.menu_dvir_title_mechanic = 'Mehaanik';
_fc_props.sidemenu_dvir = 'DVIR';
_fc_props.air_sensor_firmware = 'Õhuanduri püsivara';
_fc_props.when_no_active_ticket = 'Kui aktiivset piletit pole';
_fc_props.used_by = 'Kasutanud';
_fc_props.fields = 'Väljad';
_fc_props.are_you_sure_you_want_to_delete_ticket_layout = 'Kas olete kindel, et soovite pileti paigutuse "{0}" kustutada?';
_fc_props.menu_settings_title_ticket_layout = 'Pileti paigutus';
_fc_props.add_ticket_layout = 'Lisa pileti paigutus';
_fc_props.edit_ticket_layout = 'Muuda pileti paigutust';
_fc_props.ticket_layout_edit_modal_name = 'Nimi';
_fc_props.ticket_layout_edit_modal_default = 'Vaikimisi';
_fc_props.ticket_layout_edit_modal_error_message_name_empty = 'Viga pileti paigutuse salvestamisel: nimeväli peab olema täidetud.';
_fc_props.ticket_layout_edit_modal_error_message_name_invalid_format = 'Viga pileti paigutuse salvestamisel: nimeväli peab sisaldama ainult tähti ja numbreid';
_fc_props.ticket_layout_edit_modal_fields = 'Väljad';
_fc_props.ticket_layout_edit_modal_usage = 'Kasutus';
_fc_props.ticket_layout_has_been_removed_please_refresh_page = 'Pileti paigutus on eemaldatud. Palun värskenda lehte.';
_fc_props.more_lower_case = 'rohkem';
_fc_props.ticket_layout_edit_modal_error_selected_fields_are_empty = 'Viga pileti paigutuse salvestamisel: tuleb valida üks või mitu välja.';
_fc_props.ticket_layout_edit_modal_error_selected_statuses_are_empty = 'Viga pileti paigutuse salvestamisel: tuleb valida üks või mitu olekut.';
_fc_props.cloud_dvir__ad_hoc = 'Ajutine';
_fc_props.radius_multiplier_should_be = 'Raadiuse kordaja peaks olema ujuv arv';
_fc_props.ticket_max_activate_age_err = 'Pileti maksimaalse aktiveerimisaja minutites peaks olema täisarv.';
_fc_props.max_hotspot_unused_days_errs = 'Maksimaalne leviala kasutamata päevade arv peaks olema täisarv.';
_fc_props.begin_pour_air_content = 'Alusta õhu valamist';
_fc_props.arrival_air_content = 'Saabuva õhu sisu';
_fc_props.fully_mixed_air_content = 'Täielikult segatud õhusisaldus';
_fc_props.departure_air_content = 'Väljumisõhu sisu';
_fc_props.popup_enabled = 'Hüpikaken lubatud';
_fc_props.popup_disabled = 'Hüpikaken keelatud';
_fc_props.cloud_dvir__leave_confirmation_title = 'Hoiatus';
_fc_props.cloud_dvir__leave_confirmation_description = 'Lehelt praegu väljudes lähevad kõik muudatused kaotsi.';
_fc_props.cloud_dvir__leave_confirmation_approve = 'Kinnita';
_fc_props.cloud_dvir__leave_confirmation_abort = 'Tühista';
_fc_props.air_bt_ratio = 'Õhuanduri mõõtmine';
_fc_props.cloud_dvir__view_photos_notes = 'Kuva fotod/märkmed';
_fc_props.error_adding_the_status_it_will_create_a_blank_usage_in_another_ticket_layout = 'Staatuse lisamine loob teises piletipaigutuses tühja kasutusvälja. Kas soovite lisamisega jätkata?';
_fc_props.vehicle_does_not_have_air_sensor_license = 'Sõidukil puudub õhuanduri luba.';
_fc_props.air_sensor_installed = 'Õhuandur paigaldatud';
_fc_props.load_card = 'Laadi kaart';
_fc_props.cloud_dvir__inspection_profile = 'Kontrolliprofiil';
_fc_props.cloud_dvir__view_details = 'Vaata üksikasju';
_fc_props.cloud_dvir__certify_repairs = 'Sertifitseerige remonti';
_fc_props.cloud_dvir__repairs_made = 'Tehtud parandused';
_fc_props.cloud_dvir__repairs_not_necessary = 'Remont pole vajalik';
_fc_props.cloud_dvir__mechanic_note_from = 'Mehaaniku märkus';
_fc_props.cloud_dvir__mechanic_assignment = 'Mehaaniku ülesanne';
_fc_props.cloud_dvir__mechanic_signature_description = 'Märkige kõik allpool olevad asjakohased punktid ja allkirjastage, et sõiduk on nõuetekohaselt üle vaadatud.';
_fc_props.cloud_dvir__condition_satisfactory_label = 'Selle sõiduki seisukord on rahuldav';
_fc_props.cloud_dvir__defects_corrected_label = 'Defektid on parandatud';
_fc_props.cloud_dvir__repair_not_required_label = 'Sõiduki ohutuks kasutamiseks pole remont vajalik';
_fc_props.safety = 'Ohutus';
_fc_props.cloud_dvir__awaiting_sign = 'Ootav märk';
_fc_props.cloud_dvir__dvir_review = 'DVIR-i ülevaade';
_fc_props.settings.mobile_auto_start_navigation = 'Navigeerimise automaatne käivitamine mobiilis';
_fc_props.cloud_dvir__edit = 'Redigeeri';
_fc_props.delete_custom_label = 'Kustuta kohandatud silt';
_fc_props.cloud_dvir__error_incompatible_aux_version = 'Teie TrackIti versioon on aegunud ja mõned DVIR-i funktsioonid ei pruugi korralikult töötada. Palun värskendage TrackIti enne jätkamist.';
_fc_props.cloud_dvir__error_submit_dvir_signature = 'Allkirja üleslaadimisel läks midagi valesti. Palun proovige uuesti.';
_fc_props.max_hotspot_unused_days_error = 'Maksimaalne leviala kasutamata päevade arv on 1000 päeva.';
_fc_props.menu_dvir_title_admin_templates = 'Mallid';
_fc_props.menu.dvir = {};
_fc_props.menu.dvir.admin = {};
_fc_props.menu.dvir.admin.title = 'Administraator';
_fc_props.cloud_dvir__admin_templates = 'Mallid';
_fc_props.form_name = 'Vormi nimi';
_fc_props.form_status = 'Vormi staatus';
_fc_props.menu.dvir.title = 'DVIR';
_fc_props.cloud_dvir__option_download = 'Laadi alla';
_fc_props.cloud_dvir__option_view = 'Vaade';
_fc_props.cloud_dvir__inspectortype_driver = 'Juht';
_fc_props.menu.dvir.description = {};
_fc_props.menu.dvir.description.admin = 'Vaadake/muutke/looge kohandatud DVIR-vorme ja esildisi';
_fc_props.menu.dvir.description.mechanic = 'Vaata/muuda teostatavaid DVIR-i esildisi';
_fc_props.not_in_use = 'Ei ole kasutuses';
_fc_props.logged_in = 'sisse logitud';
_fc_props.reviewing_driver = 'Juhi ülevaatamine';
_fc_props.cloud_dvir__report_title = 'Juhi sõiduki ülevaatuse aruanne';
_fc_props.cloud_dvir__report_signed = 'allkirjastatud';
_fc_props.cloud_dvir__report_page_counter = 'Lehekülg {0}/{1}';
_fc_props.cloud_dvir__report_defects = 'Defektid';
_fc_props.cloud_dvir__report_comments = 'Kommentaarid';
_fc_props.cloud_dvir__report_inspection_table_title = 'Sõiduki ülevaatus';
_fc_props.cloud_dvir__report_driver_table_title = 'Juhi teave';
_fc_props.cloud_dvir__report_carrier = 'Vedaja';
_fc_props.cloud_dvir__report_truck = 'Veoauto';
_fc_props.cloud_dvir__report_location = 'Asukoht';
_fc_props.cloud_dvir__report_odometer = 'Odomeeter';
_fc_props.cloud_dvir__report_hours = 'Tunnid';
_fc_props.cloud_dvir__report_no_comments = 'Kommentaare pole';
_fc_props.include_unlicensed_vehicles = 'Kaasa arvatud litsentseerimata sõidukid';
_fc_props.cloud_dvir__search_by_form_name = 'Otsi vormi nime järgi';
_fc_props.cloud_dvir__create_dvir = 'Loo DVIR';
_fc_props.cloud_dvir__update_dvir = 'DVIR-i värskendamine';
_fc_props.cloud_dvir__form_name = 'Vormi nimi';
_fc_props.cloud_dvir__form_description = 'Vormi kirjeldus';
_fc_props.cloud_dvir__form_status = 'Vormi staatus';
_fc_props.information = 'Teave';
_fc_props.cloud_dvir__search_categories = 'Otsi kategooriaid';
_fc_props.cloud_dvir__create_new_category = 'Loo uus kategooria';
_fc_props.category_name = 'Kategooria nimi';
_fc_props.sub_category = 'Alamkategooria';
_fc_props.sub_category_name = 'Alamkategooria nimi';
_fc_props.delete_category = 'Kustuta kategooria';
_fc_props.cloud_dvir__dvir_information = 'DVIR-i teave';
_fc_props.cloud_dvir__dvir_choose_categories = 'Valige kategooriad';
_fc_props.cloud_dvir__create_category = 'Loo kategooria';
_fc_props.cloud_dvir__update_category = 'Värskenda kategooriat';
_fc_props.delete_route_point = 'Kustuta marsruudipunkt';
_fc_props.view_route_points = 'Vaata marsruudi punkte';
_fc_props.ignore_cancel_preload = 'Ignoreeri tühistamist, oled eellaaditud. Sinu kodujooks kuvatakse peagi.';
_fc_props.cloud_dvir__assigned_mechanic = 'Määratud mehaanik';
_fc_props.cloud_dvir__add_mechanic = 'Lisa mehaanik';
_fc_props.contact_type = 'Kontakti tüüp';
_fc_props.cloud_dvir__send_email_notifications = 'Saada e-posti teel teavitusi';
_fc_props.menu_dvir_title_admin_dvir = 'DVIR';
_fc_props.cloud_dvir__error_retrieving_dvir_history = 'Viga DVIR-i ajaloo kirjete toomisel.';
_fc_props.cloud_dvir__error_processing_dvir_record = 'DVIR-kirje toomisel tekkis viga.';
_fc_props.cloud_dvir__error_saving_submission = 'Esildise salvestamisel tekkis viga. Proovige uuesti.';
_fc_props.cloud_dvir__error_retrieving_mechanics = 'Mehaanikute loendi toomisel tekkis viga.';
_fc_props.cloud_dvir__template_saved = 'Mall salvestatud';
_fc_props.cloud_dvir__error_retrieving_dvir_templates = 'Mallide loendi toomisel tekkis viga.';
_fc_props.cloud_dvir__error_saving_dvir_template = 'Malli salvestamisel tekkis viga. Proovige uuesti.';
_fc_props.dispatch_group = 'Dispetšeri grupp';
_fc_props.save_adjust = 'Marsruudipunkti salvestamine ja kohandamine';
_fc_props.reset_route_point = 'Lähtesta marsruudipunkt';
_fc_props.no_records_stub_adjust_filters = 'Tulemuste arvu suurendamiseks proovige otsingu- või filtreerimisseadeid muuta.';
_fc_props.no_dvir_records = 'Kõik DVIR-ide peal kinni!';
_fc_props.no_dvir_records_sub_title = 'Oled palju saavutanud';
_fc_props.settings.master_data_connex_x_api_key = 'Master Data Connex x-API-võti';
_fc_props.slump_not_obtained_for_x = 'Languse näitu ei saadud järgmise kohta: {0}';
_fc_props.please_select_a_sensor_status_type = 'Selle hoiatuse käivitamiseks valige anduri oleku tüübid';
_fc_props.settings.master_data_connex_token = 'Master Data Connex Token';
_fc_props.error_validating_master_data_connex_credentials = 'Viga Master Data Connexi volituste valideerimisel';
_fc_props.settings.master_data_connex_base_url = 'Põhiandmete ühenduse baas-URL';
_fc_props.settings.master_data_connex_exp_time = 'Põhiandmete ühenduse aegumiskuupäev';
_fc_props.download_template = 'Laadi alla mall';
_fc_props.menu_settings_title_dispatch_group = 'Lähetusgrupid';
_fc_props.settings.dispatch_groups = 'Lähetusgrupid';
_fc_props.dispatch_group_name = 'Lähetusgrupi nimi';
_fc_props.dispatch_group_plants = 'Dispatch Group Plants';
_fc_props.dispatch_group_plants_mapping_message = 'Märkige, millised taimed sellesse dispetšigruppi kuuluvad.';
_fc_props.dispatch_group_users_mapping_message = 'Märkige, millised kasutajad sellesse dispetšigruppi kuuluvad.';
_fc_props.dispatch_group_plant_disassociation_message = 'Tehas peaks korraga olema ühe dispetširühma all';
_fc_props.dispatch_group_search_by_plant = 'Otsi taime nime järgi';
_fc_props.dispatch_group_search_by_username = 'Otsi kasutajanime järgi';
_fc_props.search_by_dispatch_group_name = 'Otsi dispetšerigrupi nime järgi';
_fc_props.create_dispatch_group = 'Loo lähetusgrupp';
_fc_props.update_dispatch_group = 'Värskenda lähetusgruppi';
_fc_props.dispatch_group_saved = 'Lähetusgrupp salvestatud';
_fc_props.warning_deleting_dispatch_group_unassociate_plants = 'Selle lähetusgrupi kustutamine loob seotud tehaste jaoks vaikimisi lähetusgrupid.';
_fc_props.error_saving_dispatch_group = 'Viga dispetšeri grupi salvestamisel. Proovige uuesti.';
_fc_props.please_enter_a_valid_plant_num = 'Palun sisestage kehtiv tehase number.';
_fc_props.cloud_dvir__report_no_defects = 'Defektideta';
_fc_props.shoud_select_dispatch_group = 'Peate valima vähemalt ühe lähetusgrupi';
_fc_props.one_or_more_users_are_associated_with_this_dispatch_group_only = 'Kustutamine ebaõnnestus, kuna see lähetusgrupp sisaldab kasutajaid, kes on seotud ainult selle lähetusgrupiga.';
_fc_props.cloud_dvir__username = 'Kasutajanimi';
_fc_props.cloud_dvir__password = 'Parool';
_fc_props.cloud_dvir__login = 'Sisselogimine';
_fc_props.cloud_dvir__mechanic_sign_in = 'Mehaaniku sisselogimine';
_fc_props.delete_dispatch_group = 'Kustuta lähetusgrupp';
_fc_props.cloud_dvir__driver = 'Juht';
_fc_props.cloud_dvir__equipment_pound = 'Varustus #';
_fc_props.cloud_dvir__mechanic = 'Mehaanik';
_fc_props.dispatch_group_user_only_unassociate_message = 'Kasutajat ei saa kustutada, kuna kasutajad peavad olema seotud vähemalt ühe lähetusgrupiga.';
_fc_props.cloud_dvir__time_period_filter_today = 'Täna';
_fc_props.cloud_dvir__time_period_filter_yesterday = 'Eile';
_fc_props.cloud_dvir__time_period_filter_last_7_days = 'Viimased 7 päeva';
_fc_props.cloud_dvir__time_period_filter_last_30_days = 'Viimased 30 päeva';
_fc_props.cloud_dvir__date_range_filter = 'Filtreeri kuupäeva järgi';
_fc_props.cloud_dvir__download = 'Laadi alla';
_fc_props.dispatch_group_is_empty = 'Lähetusgrupp ei tohi olla tühi.';
_fc_props.dispatch_group_with_empty_plants = 'Vähemalt üks tehas peab olema seotud lähetusgrupiga.';
_fc_props.dispatch_group_with_empty_users = 'Vähemalt üks kasutaja peab olema seotud lähetusgrupiga.';
_fc_props.not_delete_one_or_more_users_are_associated_with_this_dispatch_group_only = 'Lähetusgruppi ei saa kustutada, kuna see sisaldab kasutajaid, kes on seotud ainult selle lähetusgrupiga.';
_fc_props.dispatch_group_not_exists = 'Lähetusgruppi pole olemas.';
_fc_props.dispatch_group_contains_one_plant = 'Kustutamine ebaõnnestus, kuna see jaotusgrupp sisaldab ainult ühte tehast.';
_fc_props.dispatch_group_users = 'Lähetusgrupi kasutajad';
_fc_props.cloud_dvir__error_retrieving_dvir = 'DVIR-kirje toomisel tekkis viga';
_fc_props.cloud_dvir__assign_mechanic = 'Määra mehaanik';
_fc_props.cloud_dvir__submit_review = 'Esita arvustus';
_fc_props.error_deleting_dispatch_group = 'Viga lähetusgrupi kustutamisel.';
_fc_props.error_retrieving_dispatch_groups = 'Viga lähetusgruppide nimekirja toomisel.';
_fc_props.cloud_dvir__undo_selection = 'Tühista valik';
_fc_props.enable_master_data = 'Luba põhiandmed';
_fc_props.manually_sync = 'Käsitsi sünkroonimine';
_fc_props.master_data_connex_token_expiration = 'Põhiandmete Connexi tokeni aegumine';
_fc_props.cloud_dvir__time_period_filter_custom = 'Kohandatud';
_fc_props.settings.zello_session_timeout_minutes = 'Zello seansi aegumine (minutites)';
_fc_props.menu_settings_title_master_data = 'Põhiandmed';
_fc_props.settings.master_data = 'Põhiandmed';
_fc_props.error_retrieving_master_data = 'Põhiandmete toomisel tekkis viga';
_fc_props.master_data_sync_completed = 'Põhiandmete sünkroonimine on lõpule viidud';
_fc_props.master_data_successfully_updated = 'Andmed edukalt uuendatud';
_fc_props.master_data_failed_to_update = 'Salvestamine ebaõnnestus.';
_fc_props.master_data_sync_initiated = 'Põhiandmete sünkroonimine algatatud';
_fc_props.master_data_sync_failed = 'Põhiandmete sünkroonimine ebaõnnestus';
_fc_props.enabled_excluding_origin_on_deliveries = 'Tõsi (välja arvatud päritolumaa saatelehtedel)';
_fc_props.enabled_including_origin_on_deliveries = 'Tõene (sh päritolumaa saatelehtedel)';
_fc_props.cloud_dvir__i_will_decide_later = 'Ma otsustan hiljem';
_fc_props.returning = 'Tagasipöördumine';
_fc_props.leftover_concrete = 'Ülejäänud betoon';
_fc_props.leftover_concrete_on_vehicle_x = 'Sõidukil olevad betoonijäägid {0}';
_fc_props.leftover_concrete_alert = 'Ülejäänud betooni hoiatus';
_fc_props.wc_ratio_exceeded = 'Vee ja vee suhe ületatud';
_fc_props.search_by_site_name = 'Otsi saidi nime järgi';
_fc_props.sites = 'Saidid';
_fc_props.token_expiration = 'Tokeni aegumine';
_fc_props.menu_settings_title_connex_api_key_management = 'Connex API võtmehaldus';
_fc_props.settings.connex_api_key_management = 'Connex API võtmehaldus';
_fc_props.error_retrieving_connex_api_key_data = 'Viga connex API võtme andmete toomisel';
_fc_props.qr_code = 'QR-kood';
_fc_props.informing_driver_and_interface_when_entering_wrong_plant = 'Juhi ja liidese teavitamine valesse tehasesse sisenemisel';
_fc_props.enable_driver_message = 'Juhi sõnumi lubamine';
_fc_props.enable_dispatch_message = 'Luba saatmissõnum';
_fc_props.enable_sending_message_to_interface = 'Luba sõnumi saatmine liidesele';
_fc_props.ticket_qr_code = 'QR-kood';
_fc_props.leftover_concrete_alert_description = 'Hoiatus, kui pärast valamist leitakse betoonijääke.';
_fc_props.minimum_leftover_concrete_amount = 'Minimaalne järelejäänud betooni kogus';
_fc_props.error_validating_master_data_connex_credentials_unauthorized = 'Viga Master Data Connexi volituste valideerimisel. Pole autoriseeritud.';
_fc_props.error_validating_master_data_connex_credentials_permissions = 'Viga Master Data Connexi volituste õiguste valideerimisel';
_fc_props.error_validating_master_data_connex_url_not_found = 'Viga põhiandmete ühenduse URL-i valideerimisel';
_fc_props.error_validating_master_data_connex_unknown_error = 'Viga Master Data Connexi valideerimisel Tundmatu viga';
_fc_props.master_data_sync_failed_sync_up_vehicle_type = 'Põhiandmete sünkroonimine nurjus. Sõidukitüübi sünkroonimine.';
_fc_props.master_data_sync_failed_sync_up_vehicle = 'Põhiandmete sünkroonimine ebaõnnestus. Sünkroniseerige sõiduk.';
_fc_props.master_data_sync_failed_sync_up_plant = 'Põhiandmete sünkroonimine nurjus. Sünkroniseeri seade.';
_fc_props.master_data_sync_failed_data_base_connection = 'Põhiandmete sünkroonimine nurjus andmebaasiga ühenduse loomisel.';
_fc_props.error_validating_master_data_connex_permission_is_insufficient = 'Viga Master Data Connexi volituste valideerimisel. Omaniku tunnusloa õigused on ebapiisavad.';
_fc_props.settings.back_date_arrive_job = 'Töö saabumise kuupäev tagasi';
_fc_props.device_notifications = 'Teavitused';
_fc_props.loading_number = 'Laadimisnumber';
_fc_props.leftover_concrete_volume_temp_age = 'Jääkmaht={0}, Ajutine jääk={1}, Vanus={2}';
_fc_props.total_ordered = 'Tellitud kogukogus';
_fc_props.total_ticketed = 'Kohale toimetatud Tellitud';
_fc_props.load_number = 'Koormuse number';
_fc_props.min_leftover_concrete_must_be_filled_in_and_gt_x = 'Minimaalne betoonijääk peab olema täidetud ja suurem kui {0}';
_fc_props.error_validating_master_data_connex_credentials_are_the_same = 'Põhiandmete valideerimisel tekkis viga. Volitused ei tohi olla samad.';
_fc_props.use_aws_for_talk = 'Kasutage AWS-i vestluse jaoks';
_fc_props.air_readings_not_supported = 'Õhulugejaid ei toetata';
_fc_props.air_not_supported = 'Õhk ei ole toetatud';
_fc_props.mix_not_supported = 'Segu ei toetata';
_fc_props.air_default_and_none_not_supported = 'Vaikimisi ja mittetoetatud olekut ei saa korraga valida!';
_fc_props.notifications_enabled = 'Teavitused lubatud';
_fc_props.prevent_status_change = 'Staatuse muutmise vältimine';
_fc_props.message_to_interface = 'Sõnum liidesele';
_fc_props.prevent_wrong_plant = 'Vältige valet istutamist';
_fc_props.previous_tickets = 'Eelmised piletid';
_fc_props.audit_ticket_number = 'Pileti number';
_fc_props.audit_date_created = 'Loomise kuupäev';
_fc_props.audit_vehicle_number = 'Sõiduki number';
_fc_props.cloud_dvir__table_ok = 'Ohutu kasutada';
_fc_props.cloud_dvir__table_needs_repair = 'Ohtlik kasutamiseks';
_fc_props.missing_air_calibration = 'Õhukalibreerimise andmed puuduvad';
_fc_props.reported_defects = 'Teatatud defektid';
_fc_props.address_latitude = 'Aadressi laiuskraad';
_fc_props.address_longitude = 'Aadressi pikkuskraad';
_fc_props.routing_latitude = 'Marsruudi laiuskraad';
_fc_props.routing_longitude = 'Marsruudi pikkuskraad';
_fc_props.category_name_must_be_unique = 'Kategooria nimi peab olema unikaalne';
_fc_props.subcategory_name_must_be_unique = 'Alamkategooria nimi peab olema unikaalne';
_fc_props.menu_settings_tracking_device = 'Jälgimisseade';
_fc_props.menu_settings_title_tracking_device = 'Jälgimisseade';
_fc_props.menu_settings_title_personal_device_registration = 'Isikliku seadme registreerimine';
_fc_props.registration_code = 'Registreerimiskood';
_fc_props.creation_date = 'Loomine';
_fc_props.expiration_date = 'Aegumine';
_fc_props.trackitadmin_personal_device_registration = 'Isikliku seadme registreerimine';
_fc_props.create_registration_code = 'Lisa registreerimiskood';
_fc_props.remove_registration_code = 'Eemalda registreerimiskood';
_fc_props.add_a_registration_code = 'Lisa registreerimiskood';
_fc_props.select_number_of_registration_codes_to_generate = 'Valige registreerimiskoodide arv, mida soovite genereerida.';
_fc_props.registration_code_count = 'Registreerimiskoodide arv';
_fc_props.are_you_sure_you_want_to_delete_this_reg_code = 'Kas olete kindel, et soovite valitud registreeritud koodi kustutada?';
_fc_props.are_you_sure_you_want_to_delete_selected_reg_codes = 'Kas olete kindel, et soovite valitud registreeritud koodid kustutada?';
_fc_props.add_personal_device = 'Lisa isiklik seade';
_fc_props.menu_settings_title_personal_device = 'Isiklik seade';
_fc_props.cloud_dvir__approval_critical_alert = 'Sõidukil on kriitiline defekt. Seda ei saa ohutuks märkida.';
_fc_props.export_registration_codes = 'Ekspordi registreerimiskoodid';
_fc_props.download_format = 'Laadi alla vorming';
_fc_props.specify_download_format_x = 'Määrake {0} registreerimiskoodi eksportimiseks allalaadimisvorming';
_fc_props.personal_device_download = 'Laadi alla';
_fc_props.add_personal_device_input_message = 'Sisestage allpool isiklik seadme ID. Aegumiskuupäev rakendatakse automaatselt pärast salvestamist.';
_fc_props.error_creating_personal_device = 'Isikliku seadme loomisel tekkis viga';
_fc_props.device_already_exists = 'Isiklik seade on juba olemas';
_fc_props.export = 'Eksport';
_fc_props.error_can_not_change_connex_eid = 'Connex EID-i ei saa muuta, kuna seda kasutatakse praegu põhiandmete jaoks.';
_fc_props.remove_personal_device = 'Eemalda isiklik seade';
_fc_props.are_you_sure_you_want_to_delete_this_personal_device = 'Kas olete kindel, et soovite valitud isikliku seadme kustutada?';
_fc_props.are_you_sure_you_want_to_delete_selected_personal_devices = 'Kas olete kindel, et soovite valitud isiklikud seadmed kustutada?';
_fc_props.error_deleting_personal_device = 'Isikliku seadme kustutamisel tekkis viga';
_fc_props.customerid = 'Kliendi ID';
_fc_props.customername = 'Kliendi nimi';
_fc_props.ordernumber = 'Tellimuse number';
_fc_props.orderdescription = 'Tellimuse kirjeldus';
_fc_props.locationid = 'Asukoha ID';
_fc_props.locationdescription = 'Asukoha kirjeldus';
_fc_props.productid = 'Toote ID';
_fc_props.productdescription = 'Toote kirjeldus';
_fc_props.vehicleid = 'Sõiduki ID';
_fc_props.vehicledescription = 'Sõiduki kirjeldus';
_fc_props.ticketnumber = 'Pileti nr';
_fc_props.ticketdate = 'Pileti kuupäev/kellaaeg';
_fc_props.drivername = 'Juhi nimi';
_fc_props.arriveregion = 'Saabumispiirkond (TIME)';
_fc_props.leaveregion = 'Lahku piirkonnast (TIME)';
_fc_props.regionduration = 'Piirkonna kestus';
_fc_props.menu_reports_title_prevailing_wage = 'Valdav palk';
_fc_props.slump_calibration_x_not_found_for_y = 'Pileti {1} kalibreerimist "{0}" ei leitud';
_fc_props.slump_calibration_not_found = 'Madalseisu kalibreerimist ei leitud';
_fc_props.slump_calibration_not_found_description = 'Hoiatus, kui madalseisu kalibreerimist ei leitud';
_fc_props.error_getting_personal_device_list = 'Viga isikliku seadmete loendi toomisel';
_fc_props.batch_summary_date_range_note = '*MÄRKUS: Kui filtreid ei rakendata, on see aruanne piiratud 3 päevaga. Kuupäevavahemik võib ulatuda kuni 31 päevani, kui filtreerida seadmete (maksimaalselt 10), tehase (maksimaalselt 1), toote (maksimaalselt 1) või töö (maksimaalselt 1) järgi.';
_fc_props.select_registration_code_expiration_time_days = 'Valige päevade arv, mille möödumiseni registreerimiskoodid aeguvad, ja seejärel klõpsake nuppu Salvesta.';
_fc_props.add_personal_device_expiration = 'Aegumiskuupäev (päevades)';
_fc_props.cloud_dvir__vehicle_no = 'Sõiduki nr';
_fc_props.cloud_dvir__trailer_no = 'Haagise nr';
_fc_props.cloud_dvir__vehicle = 'Sõiduk';
_fc_props.cloud_dvir__trailer = 'Haagis';
_fc_props.cloud_dvir__truck_number_label = 'Veoauto number';
_fc_props.cloud_dvir__trailer_number = 'Haagise number';
_fc_props.cloud_dvir__has_trailer = 'Haagisega sõitmine keelatud';
_fc_props.cloud_dvir__trailer_input_field_prompt = 'Sisesta siia oma haagise number';
_fc_props.work_order = 'Töökäsk';
_fc_props.unable_to_determine_slump = 'Langust ei õnnestunud kindlaks teha';
_fc_props.cloud_dvir__determine_the_overall_condition_of_the_trailer = 'Määrake haagise üldine seisukord';
_fc_props.defaultTrailer = 'Vaikimisi treiler';
_fc_props.trailer_type_column_billable = 'Arveldatav';
_fc_props.trailer_type_column_notes = 'Märkused';
_fc_props.trailer_type_column_date = 'Kuupäev';
_fc_props.trailer_type_column_order = 'Telli';
_fc_props.trailer_type_column_ticket = 'Pilet';
_fc_props.trailer_type_column_project = 'Projekt';
_fc_props.trailer_type_column_customer = 'Klient';
_fc_props.trailer_type_column_location = 'Asukoht';
_fc_props.trailer_type_column_vehicle_type = 'Sõiduki tüüp';
_fc_props.trailer_type_column_product = 'Toode';
_fc_props.trailer_type_action_rebill = 'Arvelda uuesti';
_fc_props.master_data_sync_failed_no_default_vehicle_type_has_been_set = 'Põhiandmete sünkroonimine ebaõnnestus, vaikeseadme tüüpi pole määratud';
_fc_props.trailer_type = 'Haagise tüüp';
_fc_props.trailer_type_is_required = 'Haagise tüüp on kohustuslik';
_fc_props.trailer_number_already_exists = 'Haagise number on juba olemas';
_fc_props.plate_number_already_exists = 'Numbrimärk on juba olemas';
_fc_props.trailer_vin_already_exists = 'Treileri vin on juba olemas';
_fc_props.trailer_does_not_exist = 'Treilerit pole olemas';
_fc_props.trailer_number_is_required = 'Haagise number on kohustuslik';
_fc_props.plate_number_is_required = 'Registrinumber on kohustuslik';
_fc_props.plate_number = 'Numbrimärk';
_fc_props.menu_settings_title_trailer = 'Haagis';
_fc_props.add_trailer = 'Lisa treiler';
_fc_props.edit_trailer = 'Redigeeri treilerit';
_fc_props.menu_settings_title_equipment = 'Varustus';
_fc_props.settings_ignore_new_tickets_from_command_cloud_older_than_specified_minutes = 'Ignoreeri Command Cloudi uusi pileteid, mis on vanemad kui X minutit';
_fc_props.settings_ignore_new_tickets_from_command_cloud_older_than_specified_minutes_title = 'Ignoreeri Command Cloudist uusi pileteid, mille saatmiskuupäev ja kellaaeg on vanemad kui X minutit (vaikimisi on tühi ja välja lülitatud)';
_fc_props.edit_load_card = 'Redigeeri laadimiskaarti';
_fc_props.default_layout = 'Vaikimisi paigutus';
_fc_props.load_card_empty_fields = 'Laadimiskaardi salvestamisel tekkis viga: tuleb valida üks või mitu välja.';
_fc_props.trailers = 'Haagised';
_fc_props.error_failed_to_save_data = 'Viga: Andmete salvestamine ebaõnnestus';
_fc_props.slump_increased_plasticizer_added_question = 'Kui palju plastifikaatorit lisati?';
_fc_props.add_trailer_type = 'Lisa haagise tüüp';
_fc_props.menu_settings_title_trailer_type = 'Haagise tüüp';
_fc_props.edit_trailer_type = 'Muuda treileri tüüpi';
_fc_props.single_use_codes = 'Ühekordselt kasutatavad koodid';
_fc_props.multiple_use_codes = 'Mitmekordselt kasutatavad koodid';
_fc_props.trailer_type_description_is_required = 'Haagise tüübi kirjeldus on kohustuslik';
_fc_props.trailer_saved = 'Treiler salvestatud';
_fc_props.cloud_dvir__trailer_only_dvir = 'Ainult treiler DVIR';
_fc_props.choose_file = 'Valige fail';
_fc_props.no_file_chosen = 'Faili pole valitud';
_fc_props.please_choose_file = 'Palun vali fail';
_fc_props.no_filters = 'Filtreid pole valitud';
_fc_props.remaining_defects = 'Järelejäänud defektid';
_fc_props.load_more = 'Laadi rohkem';
_fc_props.pagination_label = '{0}-{1} {2-st';
_fc_props.extend = 'Pikendada';
_fc_props.cloud_dvir__notes_or_photo_required = 'Vaja on kas märkmeid või fotot.';
_fc_props.no_default_plant_specified_failed_to_save = 'Vaikimisi tehast pole määratud.';
_fc_props.no_default_employee_type_specified_failed_to_save = 'Vaikimisi töötaja tüüpi pole määratud.';
_fc_props.personal_device_registration_code_saved = 'Isikliku seadme registreerimiskood on salvestatud';
_fc_props.error_saving_personal_device_registration_code = 'Isikliku seadme registreerimiskoodi salvestamisel tekkis viga. Proovige uuesti.';
_fc_props.settings.master_data_sub_title = 'Põhiandmete integratsiooni seadistamine TrackIti ja Connexi vahel';
_fc_props.connex_authentication = '{0} Autentimine';
_fc_props.select_company = 'Valige ettevõte';
_fc_props.requirements = 'Nõuded';
_fc_props.default_plant_type = 'Vaikimisi tehas';
_fc_props.default_employee_type = 'Vaikimisi töötaja tüüp';
_fc_props.default_equipment_type = 'Vaikimisi seadmetüüp';
_fc_props.support_alphanumeric_trucks = 'Toetage tähtnumbrilisi veoautosid';
_fc_props.no_default_equipment_type_specified_failed_to_save = 'Vaikimisi seadmetüüpi pole määratud.';
_fc_props.air_pau_battery_low_message = 'Air PAU aku tühjenemise hoiatus';
_fc_props.air_pau_battery_low = 'Õhu PAU aku tühjenemas';
_fc_props.alert_when_air_pau_battery_low = 'Hoiatus, kui Air PAU aku tühjeneb';
_fc_props.air_pau_battery_low_alert = 'Õhuaku tühjenemise hoiatus';
_fc_props.sensor_unable_to_determine_slump = 'Andur ei suuda madalseisu tuvastada';
_fc_props.menu_settings_title_export = 'Eksport';
_fc_props.compare_company = 'Võrdle teise ettevõttega';
_fc_props.site_settings = 'Saidi seaded';
_fc_props.permission_type = 'Loa tüüp';
_fc_props.ticket_integration = 'Piletite integreerimine';
_fc_props.select_one_or_more_settings = 'Palun valige üks või mitu seadet';
_fc_props.export_tooltip = 'See valik on saadaval ainult siis, kui kuulute mitmesse ettevõttesse.';
_fc_props.select_company_error = 'Palun valige ettevõte';
_fc_props.audible = 'Kuuldav';
_fc_props.deleted_master_data_successfully = 'Põhiandmed edukalt kustutatud';
_fc_props.cloud_dvir__units_miles_abbr = 'MI';
_fc_props.cloud_dvir__units_kilometers_abbr = 'KM';
_fc_props.create_hauler_order = 'Loo veotellimus';
_fc_props.send_gps = 'Saada GPS';
_fc_props.cloud_dvir__search_results = 'Otsingutulemused';
_fc_props.cloud_dvir__advanced_filter = 'Täpsem filter';
_fc_props.preload = 'Eellaadimine';
_fc_props.job_name = 'Töö nimi';
_fc_props.delivery_address = 'Tarneaadress';
_fc_props.total_water_added = 'Lisatud vee kogus';
_fc_props.total_customer_water_added = 'Klientide lisatud vee koguarv';
_fc_props.concrete_volume = 'Betooni maht';
_fc_props.water_events_and_volume = 'Veesündmused ja maht';
_fc_props.menu.reports.title.water_events_and_volume = 'Veesündmused ja maht';
_fc_props.menu.reports.description = {};
_fc_props.menu.reports.description.water_events_and_volume = 'Vaadake piletitele lisatud vett erinevas staatuses ja rühmitustes';
_fc_props.returned_concrete_volume = 'Tagastatud betooni maht';
_fc_props.customer_water_added = 'Kliendi lisatud vesi';
_fc_props.averages_and_totals = 'Keskmised ja kokkuvõtted';
_fc_props.preload_loading = 'Eellaadimine';
_fc_props.preload_loaded = 'Eellaadimine laaditud';
_fc_props.send = 'Saada';
_fc_props.deliveries_iframe_url = 'Kohaletoimetamise IFrame\'i URL';
_fc_props.bulk_ticket_completion = 'Hulgipiletite täitmine';
_fc_props.ticket_type = 'Pileti tüüp';
_fc_props.complete_tickets = 'Täielikud piletid';
_fc_props.tickets_found = 'Pilet(id) leitud';
_fc_props.include_preload = 'Lisa eellaadimine';
_fc_props.exclude_preload = 'Välista eellaadimine';
_fc_props.selected_tickets = 'Valitud piletid';
_fc_props.are_you_sure_you_want_to_complete_selected_tickets = 'Kas oled kindel, et soovid valitud piletid lõpule viia?';
_fc_props.completing_tickets = 'Piletite_täitmine';
_fc_props.some_tickets_failed_to_complete = 'Mõned piletid ebaõnnestusid';
_fc_props.bulk_ticket_complete_failed = 'Hulgipileti täitmine ebaõnnestus';
_fc_props.ticket_management = 'Piletite haldamine';
_fc_props.invalid_url_for_deliveries = 'Kehtetu URL tarnete jaoks';
_fc_props.menu_dvir_title_translations = 'Tõlked';
_fc_props.cloud_dvir__dvir_translation = 'Tõlge';
_fc_props.template = 'Mall';
_fc_props.menu_dvir_title_admin_translations = 'Tõlked';
_fc_props.menu.dvir.description.translations = 'Vaata DVIR-i tõlkeid';
_fc_props.cloud_dvir__driver_review = 'Juhi ülevaade';
_fc_props.cloud_dvir__mechanic_review = 'Mehaaniku ülevaade';
_fc_props.cloud_dvir__driver_approval = 'Juhi heakskiit';
_fc_props.cloud_dvir__dvir_event_type = 'DVIR-i sündmuse tüüp';
_fc_props.cloud_dvir__option_print_signed = 'Prinditud allkiri';
_fc_props.deliveries_cloud_auth_enabled = 'Kasutage kohaletoimetamiseks pilveautentimist';
_fc_props.deliveries_host_name = 'Tarnete hostinimi';
_fc_props.cloud_dvir__option_event_history = 'Sündmuste ajalugu';
_fc_props.ticketed_plant = 'Piletiga tehas';
_fc_props.cloud_dvir__all_notes_and_photos_will_be_removed = 'Kõik märkmed ja fotod eemaldatakse';
_fc_props.cloud_dvir__continue = 'Jätka';
_fc_props.cloud_dvir__cancel = 'Tühista';
_fc_props.engine_diagnostic_canbaudrate_1 = 'CAN 1';
_fc_props.engine_diagnostic_canbaudrate_2 = 'CAN 2';
_fc_props.attached = 'Lisatud';
_fc_props.cloud_dvir__images = 'Pildid';
_fc_props.settings.ticket_voided_status_change = 'Kui pilet on tühistatud, muutke staatust järgmiselt:';
_fc_props.ticket_voided_status_change_duplication_error = 'Tühistatud pileti staatuse muutmine: Iga staatusetsükli jaoks saab valida ainult ühe staatuse';
_fc_props.cloud_not_sending_events = 'Pilveüksuse ID on määratud, aga sündmusi pilve ei saadeta';
_fc_props.set_ticket_integration_send_to_event_bus = 'Määrake piletite integreerimise seadetes sündmuste sillale saatmise olek/asukoht väärtuseks tõene';
_fc_props.cloud_missing_loading = 'Pilveintegratsioon, mille olekutüübis pole LAADIMISE oleku tähendust määratud';
_fc_props.cloud_assign_loading = 'Määrake LAADIMISE staatus, mis tähendab, et laadimise staatus pilvest muutub';
_fc_props.cloud_missing_loaded = 'Pilveintegratsioon LOADED olekuga, mis tähendab, et olekutüübis pole seda määratud';
_fc_props.cloud_assign_loaded = 'Määrake LAADITUD olek, mis tähendab, et laaditud oleku muutus pilvest toimub';
_fc_props.employee_no_valid_type = 'Töötajad, kellele pole määratud kehtivat töötajatüüpi';
_fc_props.employee_assign_valid_type = 'Veenduge, et kõigile töötajatele oleks määratud kehtiv töötaja tüüp';
_fc_props.employee_no_valid_home_plant = 'Töötajad, kellele pole määratud kehtivat kodutehast';
_fc_props.employee_assign_valid_home_plant = 'Veenduge, et kõigile töötajatele on määratud kodune taim';
_fc_props.employee_dup_alt_num = 'Töötajad, kellel on topeltalternatiivne töötajanumber';
_fc_props.employee_fix_dup_alt_num = 'Veenduge, et kõigil töötajatel oleks unikaalne alternatiivne töötajanumber';
_fc_props.employee_type_no_default = 'Vaikimisi töötajatüüpi pole';
_fc_props.employee_type_assign_default = 'Määrake töötaja vaiketüüp';
_fc_props.equipment_type_no_default = 'Vaikimisi seadmetüübi puudumine';
_fc_props.equipment_type_assign_default = 'Määrake vaikeseadme tüüp';
_fc_props.equipment_type_not_used = 'Määramata seadmete tüübid';
_fc_props.equipment_type_assign_not_used = 'Eemaldage kasutamata seadmetüübid';
_fc_props.equipment_no_valid_type = 'Seade, millele pole määratud kehtivat seadmetüüpi';
_fc_props.equipment_assign_valid_type = 'Veenduge, et kõikidele seadmetele oleks määratud kehtiv seadmetüüp.';
_fc_props.equipment_no_valid_home_plant = 'Seade, millele pole määratud kehtivat kodujaama';
_fc_props.equipment_assign_valid_home_plant = 'Veenduge, et kõikidele seadmetele on määratud koduelektrijaam.';
_fc_props.equipment_no_valid_last_plant = 'Seadmed, millele pole kehtivat viimast tehast määratud';
_fc_props.equipment_assign_valid_last_plant = 'Veenduge, et kõikidele seadmetele on määratud viimane tehas.';
_fc_props.equipment_dup_interface_num = 'Duplikaatsete liidesenumbritega seadmed';
_fc_props.equipment_fix_dup_interface_num = 'Veenduge, et kõigil seadmetel oleks unikaalne liidesenumber';
_fc_props.equipment_no_vin = 'Seadmel on Cloud DVIR, aga vin-kood puudub';
_fc_props.equipment_assign_vin = 'Uuenda varustust, et saada vin-kood';
_fc_props.equipment_probe_no_drum_type = 'Sondilitsentsiga, kuid trumlitüübita seadmed';
_fc_props.equipment_probe_assign_drum_type = 'Trumlitüübi lisamiseks värskendage seadmeid';
_fc_props.equipment_drs_no_drum_type = 'Varustus trumli pöörlemisanduriga, kuid ilma trumlitüübita';
_fc_props.equipment_drs_assign_drum_type = 'Trumlitüübi lisamiseks värskendage seadmeid';
_fc_props.equipment_ed_no_config = 'Mootori diagnostika litsentsiga ja konfiguratsioonita seadmed';
_fc_props.equipment_ed_assign_no_config = 'Varustuse värskendamine mootori diagnostika konfiguratsiooni saamiseks';
_fc_props.plant_no_dispatch_group = 'Jaamad ilma dispetšerigrupita';
_fc_props.plant_assign_dispatch_group = 'Määrake taimed olemasolevatele jaotusgruppidele või salvestage taimed uuesti, et jaotusgruppe määrata';
_fc_props.plant_dup_num = 'Taim, millel on topelt taimenumbrid';
_fc_props.plant_fix_dup_num = 'Veenduge, et kõigil tehastel oleks unikaalne number';
_fc_props.plant_dup_interface_num = 'Duplikaatsete liidesnumbritega seade';
_fc_props.plant_fix_dup_interface_num = 'Veenduge, et kõigil tehastel oleks unikaalne liidesenumber';
_fc_props.status_types_no_default_hotspot_type = 'Olekutüübid, millel puudub vaikimisi leviala tüüp';
_fc_props.status_types_assign_default_hotspot_type = 'Määrake olekutüübi jaoks vaike-leviala tüüp';
_fc_props.hotspot_type_no_valid_enter_status = 'Leviala tüüp, sisestage olek, mida enam ei eksisteeri';
_fc_props.hotspot_type_assign_valid_enter_status = 'Värskenda leviala tüüpi, et sellel oleks kehtiv sisestusolek või puuduks olek';
_fc_props.hotspot_type_no_valid_exit_status = 'Leviala tüübi väljumise olekut enam ei eksisteeri';
_fc_props.hotspot_type_assign_valid_exit_status = 'Värskenda leviala tüüpi, et sellel oleks kehtiv väljumisstaatus või et see puuduks';
_fc_props.hotspot_type_not_usable = 'Olekutüübi jaoks, mis pole määratud ühelegi seadmetüübile, on olemas leviala tüüp';
_fc_props.hotspot_type_fix_not_usable = 'Valida leviala tüübi kasutamine. Kui seda tüüpi levialasid luuakse, siis neid kaardil ei kuvata.';
_fc_props.hotspot_invalid_hotspot_type = 'Püsival levialal puudub leviala tüüp';
_fc_props.hotspot_assign_hotspot_type = 'Värskenda leviala, et sellel oleks kehtiv leviala tüüp';
_fc_props.plant_hotspot_conflict = 'Plant Hotspotil on vastuoluline taime määramine';
_fc_props.plant_hotspot_fix_conflict = 'Taimele määratud tehas erineb pileti määramisel määratud tehasest, kontrollige tehase määramist levialale, lahendamiseks võib olla vaja tehase leviala uuesti luua';
_fc_props.plant_hotspot_restricted = 'Taimede leviala on piiratud teatud piletitega';
_fc_props.plant_hotspot_fix_restricted = 'Taimede leviala on piiratud teatud piletitega, lahendamiseks tuleb taimede leviala uuesti luua.';
_fc_props.status_type_not_used = 'Staatuse tüüp pole ühelegi seadmetüübile määratud';
_fc_props.status_type_fix_not_used = 'Soovitame olekutüübi kustutada, kui seda pole vaja.';
_fc_props.status_type_no_first = 'Staatuse tüüp puudub Eesnimi Staatus';
_fc_props.status_type_fix_no_first = 'Määrake olekutüübile esimene olek';
_fc_props.status_type_no_last = 'Staatuse tüüp puudub Viimane staatus';
_fc_props.status_type_fix_no_last = 'Määrake oleku tüübile viimane olek';
_fc_props.question_no_input_format = 'Küsimusel puudub sisestusvorming';
_fc_props.question_assign_input_format = 'Määrake küsimusele vorming';
_fc_props.ticket_no_concrete_product = 'DRS-i või sondi pilet ja tootel puuduv kuupmeetri või -jardi mõõtühikute arv';
_fc_props.ticket_fix_no_concrete_product = 'Kontrollige pileti allikat ja veenduge, et integratsioon saadab õige mõõtühiku.';
_fc_props.ticket_preload_no_status_meaning = 'Piletite eellaadimine, aga eellaadimise oleku tähendused puuduvad';
_fc_props.ticket_preload_assign_status_meaning = 'Eellaadimise piletite seadistusoleku tähendused';
_fc_props.question_setup_no_end_miles = 'Küsimuse seadistamine Ainult algusmiilid on seatud';
_fc_props.question_setup_assign_end_miles = 'Uuenda küsimuse seadistust, et see hõlmaks nii algus- kui ka lõppmiile';
_fc_props.question_setup_no_begin_miles = 'Küsimuse seadistamine on seatud ainult lõppmiilidele';
_fc_props.question_setup_no_end_hours = 'Küsimuse seadistamine on määranud ainult algusajad';
_fc_props.question_setup_assign_end_hours = 'Uuenda küsimuse seadistust, et see sisaldaks nii algus- kui ka lõppaega';
_fc_props.question_setup_no_begin_hours = 'Küsimuse seadistuse ainult lõpptunnid on määratud';
_fc_props.question_setup_no_last_plant = 'Küsimuse seadistus ei määra seadmete viimast tehast';
_fc_props.question_setup_assign_last_plant = 'Uuenda küsimuse seadistust, et lisada viimase seadme seadistus seadmete jaoks';
_fc_props.device_not_used = 'Aktiivne seade, mida pole viimase 6 kuu jooksul kasutatud';
_fc_props.device_delete_not_used = 'Veenduge, et seadmeid on endiselt vaja';
_fc_props.cloud_integration = 'Pilveintegratsioon';
_fc_props.user_not_used = 'Saidi kasutajad pole sisse loginud üle 6 kuu';
_fc_props.user_delete_not_used = 'Eemalda kasutajad, kes sisse ei logi';
_fc_props.no_configuration_errors = 'Konfiguratsioonivigu pole';
_fc_props.configuration_error_summary = 'Konfiguratsiooni kokkuvõte';
_fc_props.configuration_errors = 'Konfiguratsioon';
_fc_props.question_setup = 'Küsimuse seadistamine';
_fc_props.plant_no_default = 'Vaikimisi tehast pole';
_fc_props.plant_assign_default = 'Määrake vaikeseade';
_fc_props.master_data_error_logs = 'Põhiandmete vealogid';
_fc_props.master_data_error_logs_fetch_failed = 'Põhiandmete vealogide toomine ebaõnnestus';
_fc_props.equipment_flow_meter_no_pulse = 'Seadmel on voolumõõtur, kuid impulsi kohta mahtu ei ole';
_fc_props.equipment_flow_meter_fix_no_pulse = 'Määrake seadme voolumõõturile impulsi kohta maht';
_fc_props.equipment_flow_meter_no_unit = 'Seadmel on voolumõõtur, aga veemõõtjat pole valitud';
_fc_props.equipment_flow_meter_fix_no_unit = 'Määrake seadmel olevale voolumõõturile veeühik';
_fc_props.warn = 'Hoiata';
_fc_props.security = 'Turvalisus';
_fc_props.error_validating_master_data_entity_not_found = 'Põhiandmete valideerimisel tekkis viga, üksust ei leitud';
_fc_props.device_message_queue_not_assigned = 'device_message_queue_id või device_message_canary_queue_id pole hostinime jaoks andmebaasiserveris määratud';
_fc_props.device_message_queue_not_assigned_resolution = 'Vaja on kehtivaid device_message_queue_id ja device_message_canary_queue_id väärtusi andmebaasiserveris';
_fc_props.talk_queue_not_assigned = 'talk_queue_id või talk_canary_queue_id pole hostinime jaoks andmebaasiserveris määratud';
_fc_props.talk_queue_not_assigned_resolution = 'Vaja on kehtivaid talk_queue_id ja talk_canary_queue_id väärtusi andmebaasiserveris';
_fc_props.device_message_queue_dne = 'device_message_queue_id ei eksisteeri andmebaasi_serveri_id jaoks';
_fc_props.device_message_queue_dne_resolution = 'Vajalik on kehtiv device_message_queue_id tabeli database_server jaoks.';
_fc_props.device_message_canary_queue_dne = 'device_message_canary_queue_id ei eksisteeri andmebaasi_serveri_id jaoks';
_fc_props.device_message_canary_queue_dne_resolution = 'Vajalik on kehtiv device_message_canary_queue_id tabeli database_server jaoks.';
_fc_props.talk_queue_id_dne = 'andmebaasi_serveri_id jaoks pole vestlusjärjekorra_id olemas';
_fc_props.talk_queue_id_dne_resolution = 'Vajalik on kehtiv talk_queue_id tabeli database_server jaoks';
_fc_props.talk_canary_queue_id_dne = 'talk_canary_queue_id ei eksisteeri andmebaasi_serveri_id jaoks';
_fc_props.talk_canary_queue_id_dne_resolution = 'Vajalik on kehtiv talk_canary_queue_id tabeli database_server jaoks';
_fc_props.device_message_queue_no_default = 'device_message_queue\'il puudub vaikeväärtus';
_fc_props.device_message_queue_no_default_resolution = 'Määrake device_message_queue\'is vaikeväärtus';
_fc_props.message_queue_url_dne = 'message_queue_url on device_message_queue\'is tühi';
_fc_props.message_queue_url_dne_resolution = 'Vajalik on kehtiv message_queue_url device_message_queue\'is';
_fc_props.talk_queue_url_dne = 'talk_queue_url on device_message_queue\'is null';
_fc_props.talk_queue_url_dne_resolution = 'Vajalik on kehtiv talk_queue_url device_message_queue\'is';
_fc_props.database_server_id_dne = 'ettevõtte andmebaasi_serveri_id-d ei eksisteeri';
_fc_props.database_server_id_dne_resolution = 'Vajalik on kehtiv database_server_id tabelis database_server';
_fc_props.dbname_assigned_dne = 'Kasutajatele on andmebaasinimi määratud, aga ettevõtet pole olemas';
_fc_props.dbname_assigned_dne_resolution = 'Eemalda user_db kirjetest, kus andmebaasi_nimi puudub';
_fc_props.canary_totals = 'Kanaari kokkuvõtted';
_fc_props.failed_to_find_trackit_environment = 'TrackItEnvironmenti leidmine ebaõnnestus';
_fc_props.failed_to_find_trackit_environment_resolution = 'Hostinimi pole TrackItEnvironmentis tõenäoliselt kaardistatud';
_fc_props.quartz_jobs_not_scheduled = 'Puuduvad kvartsist töökohad';
_fc_props.quartz_jobs_not_scheduled_resolution = 'Planeeri puuduvad tööd';
_fc_props.database_dne_for_company = 'Ettevõtte andmebaasis pole midagi.';
_fc_props.database_dne_for_company_resolution = 'Eemalda ettevõte nii ettevõtete tabelist kui ka kasutaja_db tabelist';
_fc_props.deliveries_not_using_cloud_auth = 'Kohaletoimetamine ei kasuta pilveautentimist';
_fc_props.deliveries_not_using_cloud_auth_resolution = 'Luba piletite integreerimise seadetes tarnete pilveautentimine';
_fc_props.talk_using_quartz_scheduler = 'Vestlus kasutab Quartz Schedulerit';
_fc_props.talk_using_quartz_scheduler_resolution = 'Luba saidi seadetes AWS-i kasutamine vestluse jaoks';
_fc_props.data_migration_scheduled_and_shouldnt = 'Andmete migreerimine on ajastatud ja seda ei tohiks teha';
_fc_props.data_migration_scheduled_and_shouldnt_resolution = 'Keela andmete migreerimise kvartsi töö';
_fc_props.data_migration_not_scheduled = 'Andmete migreerimist ei ole ajastatud ja see peaks toimuma.';
_fc_props.data_migration_not_scheduled_resolution = 'Luba andmete migreerimise kvartsi töö';
_fc_props.data_migration_not_allowed = 'Andmete migreerimine pole lubatud';
_fc_props.data_migration_allowed_on = 'Andmete migreerimine lubatud';
_fc_props.enable_data_migration = 'Luba andmete migratsioon iga ettevõtte jaoks';
_fc_props.disable_data_migration = 'Keela andmete migratsioon iga ettevõtte jaoks';
_fc_props.delayed_jobs_resolution = 'Päästikute taasloomine, päästikute kustutamine või QuartzManageri taaskäivitamine';
_fc_props.environment_setup = 'Keskkonna kokkuvõte';
_fc_props.deprecated = 'Aegunud';
_fc_props.quartz_scheduler = 'Quartz Scheduler';
_fc_props.device_queues = 'Seadmete järjekorrad';
_fc_props.data_migration = 'Andmete migratsioon';
_fc_props.delayed_jobs = 'Hilinenud tööd';
_fc_props.hide_find_truck_menu_option = 'Peida menüüvalik „Leia veoauto”';
_fc_props.configuration_audit_info = 'Konfiguratsiooni auditi teave';
_fc_props.the_master_data_is_not_enabled_yet = 'Põhiandmed pole veel lubatud';
_fc_props.the_master_data_enablement_audit_info = 'Kasutaja on {0} põhiandmeid';
_fc_props.on_lower = 'peal';
_fc_props.enabled_lower = 'lubatud';
_fc_props.disabled_lower = 'puudega';
_fc_props.mechanic_updated_successfully = 'Mehaanik on edukalt uuendatud.';
_fc_props.no_audit_record = 'Auditiprotokolli pole saadaval.';
_fc_props._7_years = '7 aastat (arhiiv)';
_fc_props.retention_continue = 'Jätka';
_fc_props.retention_save_confirm_message = 'See mõjutab serveris talletatud andmete hulka ja eemaldatud andmeid EI SAA TAASTA. Kas soovite jätkata?';
_fc_props.cloud_dvir__uom_change_confirmation_title = 'Odomeetri ühikute ja väärtuste kinnitamine';
_fc_props.cloud_dvir__uom_change_confirmation = 'Praegune odomeetri näit on {{engineValue}} {{engineUom}} ja sisestatud odomeetri näit on {{fromValue}} {{fromUom}}. Kas see on õige?';

export default _fc_props;
